
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8fb5x", function(module, exports) {

$parcel$export(module.exports, "EditorByLineArea", () => $d54487d18f54cde1$export$a5fad03eb2e226dc);
/* EditorByLineArea.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ipPpS = parcelRequire("ipPpS");

var $5zuN8 = parcelRequire("5zuN8");

var $luv00 = parcelRequire("luv00");

var $9wGTI = parcelRequire("9wGTI");

var $eVxJD = parcelRequire("eVxJD");

var $9NQ2h = parcelRequire("9NQ2h");

var $7qnBP = parcelRequire("7qnBP");
const $d54487d18f54cde1$var$EditorByLineWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $d54487d18f54cde1$var$Spacer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $d54487d18f54cde1$var$RightArea = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1tkexy5q _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $d54487d18f54cde1$export$a5fad03eb2e226dc = ({ contentId: contentId, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, editorAppearanceButton: editorAppearanceButton, isLivePage: isLivePage, isKnowledgeBaseSpace: isKnowledgeBaseSpace, viewMode: viewMode, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, isSpaceOverview: isSpaceOverview })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { workflowStatus: workflowStatus } = (0, $9NQ2h.useWorkflowStatus)();
    if (isSpaceOverview) return null;
    if (isLivePage || (0, $9wGTI.fg)('cc_page_experiences_new_editor_byline')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d54487d18f54cde1$var$EditorByLineWrapper, {
        "data-vc": "editor-byline-wrapper",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7qnBP.LivePagesByLine), {
        contentId: contentId,
        contentType: contentType,
        isPublishingContent: isPublishingContent,
        userOffline: userOffline,
        isKnowledgeBaseSpace: isKnowledgeBaseSpace,
        viewMode: viewMode,
        editorApi: editorApi,
        isUnpublishedDraft: isUnpublishedDraft
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d54487d18f54cde1$var$EditorByLineWrapper, {
        "data-vc": "editor-byline-wrapper",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d54487d18f54cde1$var$Spacer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d54487d18f54cde1$var$RightArea, {
        "data-testId": "editor-byline-right-area"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $5zuN8.ContentStateStateContainer)
        ]
    }, (contentStateState)=>{
        // view mode users should not be able to edit the content state, so we just render the content state.
        if (viewMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5zuN8.RendererContentState), {
            contentId: contentId,
            hasSeparator: false,
            isDraft: true // this sets the query to use draft version over published version
        });
         // Replace Content State with a similar Workflow state container once a workflow has been selected.
        if (workflowStatus && (0, $9wGTI.fg)('document_workflows')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eVxJD.WorkflowStatusLoader), null);
         // Knowledge space pages without the new byline will always show the editable content state component in this area.
        // Other pages will only show the editable content state component if the content state is already set.
        // This is because a page without a content state is initialized by the ContentStateHoverButton component.
        return (contentStateState.state.contentState || isKnowledgeBaseSpace) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5zuN8.EditorContentState), {
            contentId: contentId,
            contentType: contentType,
            isPublishingContent: isPublishingContent,
            userOffline: userOffline
        });
    }), !viewMode && !(isSpaceOverview && (0, $9wGTI.fg)('cc_page_experiences_new_editor_byline')) && editorAppearanceButton)));
};

});
parcelRegister("eVxJD", function(module, exports) {

$parcel$export(module.exports, "WorkflowStatePageEntryLoader", () => $860613c052e1dbcd$export$388ac97307aac1fe);
$parcel$export(module.exports, "WorkflowStatusLoader", () => $860613c052e1dbcd$export$ff1a5a6692833a7f);

var $jmjWc = parcelRequire("jmjWc");

const $860613c052e1dbcd$export$388ac97307aac1fe = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Pe5y",
    name: "WorkflowStatePageEntryLoader",
    loader: async ()=>(await (parcelRequire("1xnXG"))).WorkflowStatePageEntry
});

const $860613c052e1dbcd$export$ff1a5a6692833a7f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dguAP",
    name: "WorkflowStatusLoader",
    loader: async ()=>(await (parcelRequire("dWNM7"))).WorkflowStatusComponent
});

});
parcelRegister("1xnXG", function(module, exports) {

let $11eb75ced66882b5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $11eb75ced66882b5$var$load("6qah4"),
    $11eb75ced66882b5$var$load("dzXtg")
]).then(()=>parcelRequire('2XV15'));

});

parcelRegister("dWNM7", function(module, exports) {

let $a2774d77b46a3bbc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a2774d77b46a3bbc$var$load("6qah4"),
    $a2774d77b46a3bbc$var$load("4odwV")
]).then(()=>parcelRequire('aTxPF'));

});


parcelRegister("9NQ2h", function(module, exports) {

$parcel$export(module.exports, "useWorkflowStatus", () => $741da7191586fe61$export$3070b9a24421340b);

var $j1Ss3 = parcelRequire("j1Ss3");

var $d2LG0 = parcelRequire("d2LG0");

var $ixUm0 = parcelRequire("ixUm0");

var $9wGTI = parcelRequire("9wGTI");

var $ep3mz = parcelRequire("ep3mz");

var $bQm3c = parcelRequire("bQm3c");
const $741da7191586fe61$var$useWorkflowStatusQuery = (0, $d2LG0.gql)`
	query useWorkflowStatusQuery($contentId: ID!) {
		confluence_workflowApplicationsByContentId(contentId: $contentId, first: 50) {
			nodes {
				currentWorkflowStatus {
					id
					displayProperties {
						name
						color
					}
				}
				availableTransitions {
					id
					displayProperties {
						name
						description
					}
					startStatus {
						displayProperties {
							name
						}
					}
					destinationStatus {
						displayProperties {
							name
						}
					}
				}
			}
		}
	}
`;
const $741da7191586fe61$export$3070b9a24421340b = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageAri = contentId ? (0, $ixUm0.ConfluencePageAri).create({
        siteId: cloudId,
        pageId: contentId
    }).toString() : undefined;
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)($741da7191586fe61$var$useWorkflowStatusQuery, {
        skip: !pageAri || !(0, $9wGTI.fg)('document_workflows'),
        variables: {
            contentId: pageAri
        }
    });
    const workflowStatus = data?.confluence_workflowApplicationsByContentId?.nodes?.[0];
    return {
        workflowStatus: workflowStatus,
        loading: loading,
        error: error
    };
};

});

parcelRegister("7qnBP", function(module, exports) {

$parcel$export(module.exports, "LivePagesByLine", () => $d898e2893b08edbf$export$7ee26dfdd6e2e40f);

var $diswb = parcelRequire("diswb");

var $gwFzn = parcelRequire("gwFzn");

var $dIouf = parcelRequire("dIouf");

var $9wGTI = parcelRequire("9wGTI");

var $7Sm4c = parcelRequire("7Sm4c");

var $ep3mz = parcelRequire("ep3mz");

var $3jwuS = parcelRequire("3jwuS");

var $72lVk = parcelRequire("72lVk");

var $80xNa = parcelRequire("80xNa");

var $4J61X = parcelRequire("4J61X");

var $gaqtW = parcelRequire("gaqtW");

var $ausiN = parcelRequire("ausiN");

var $83fWZ = parcelRequire("83fWZ");
const $d898e2893b08edbf$export$7ee26dfdd6e2e40f = ({ contentId: contentId, contentType: contentType, viewMode: viewMode, isPublishingContent: isPublishingContent, isKnowledgeBaseSpace: isKnowledgeBaseSpace, userOffline: userOffline, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const lastLoadedQueryData = (0, $gwFzn.useRef)(null);
    // eslint-disable-next-line prefer-const
    let { data: data, loading: loading, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $72lVk.ContentHeaderUnifiedQuery), {
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            // Don't omit versionOverride, embeddedContentRender and limit
            // It's an Apollo bug that if preloader these needs to be match preloaded query
            // Also doesn't work if removing them from preloader variables HOT-109035
            versionOverride: null,
            embeddedContentRender: null,
            limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
            ...isUnpublishedDraft && !isLivePage && {
                status: [
                    'draft'
                ]
            }
        },
        context: {
            single: true
        },
        fetchPolicy: 'cache-and-network'
    });
    const renderByLine = ()=>{
        if (loading) {
            // If we're loading because the LivePagesByLineWithContributorsComponent called our
            // fetchAllContributors, then we should continue the render with data
            // cached from the previous query (the one with the low
            // contributorsFetchLimit). It's important to not bring the skeletons back
            // up, as that'd kill the opening of the dropdown.
            if (lastLoadedQueryData.current) data = lastLoadedQueryData.current;
            else return (0, $9wGTI.fg)('cc_page_experiences_live_pages_byline_placeholder') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ausiN.LivePagesByLinePlaceholderComponent), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4J61X.ByLinePlaceholder), null);
        } else if (!error) lastLoadedQueryData.current = data || null;
        const content = data?.content?.nodes?.[0];
        if (error) {
            if ((0, $dIouf.isUnauthorizedError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return null;
            } else // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
            // so returning empty `<ErrorDisplay>` here.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
                error: error
            });
        } else if (!content) return null;
        const contributorProps = $d898e2893b08edbf$export$6dbfb663651d0abf(content, data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gaqtW.LivePagesByLineWithContributorsComponent), {
            ...contributorProps,
            contentId: contentId,
            contentType: contentType,
            viewMode: viewMode,
            isPublishingContent: isPublishingContent,
            isKnowledgeBaseSpace: isKnowledgeBaseSpace,
            userOffline: userOffline,
            editorApi: editorApi,
            isUnpublishedDraft: isUnpublishedDraft
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).PAGE_MODES
    }, renderByLine());
};
const $d898e2893b08edbf$export$6dbfb663651d0abf = (content, data)=>{
    const author = (0, $83fWZ.toUserProps)(content?.history?.createdBy);
    const owner = content?.history?.ownedBy && (content?.type === 'page' || content?.type === 'blogpost') ? (0, $83fWZ.toUserProps)(content?.history?.ownedBy) : null;
    const lastOwner = content?.history?.lastOwnedBy && (content?.type === 'page' || content?.type === 'blogpost') ? (0, $83fWZ.toUserProps)(content?.history?.lastOwnedBy) : null;
    const createdDateString = content?.history?.createdDate;
    const createdDate = createdDateString ? new Date(createdDateString) : null;
    const lastModifyUser = (0, $83fWZ.toUserProps)(content?.version?.by);
    const version = {
        friendlyWhen: content?.version?.friendlyWhen || '',
        number: Number(content?.version?.version || ''),
        by: lastModifyUser,
        contentTypeModified: content?.version?.contentTypeModified || false
    };
    const contributors = data?.contentContributors?.nodes?.map((0, $83fWZ.toUserProps)) || [];
    const contributorsCount = data?.contentContributors?.count || 0;
    const isOwnerContributor = data?.contentContributors?.isOwnerContributor;
    return {
        author: author,
        owner: owner,
        lastOwner: lastOwner,
        createdDate: createdDate,
        lastModifyUser: lastModifyUser,
        contributors: contributors,
        contributorsCount: contributorsCount,
        isOwnerContributor: isOwnerContributor,
        version: version
    };
};

});
parcelRegister("72lVk", function(module, exports) {

$parcel$export(module.exports, "ContentHeaderUnifiedQuery", () => $51f9b9ddd102dc1f$export$2b17287e63c772da);

var $d2LG0 = parcelRequire("d2LG0");

var $5byFK = parcelRequire("5byFK");

var $8sR0p = parcelRequire("8sR0p");
const $51f9b9ddd102dc1f$export$2b17287e63c772da = (0, $d2LG0.default)`query ContentHeaderUnifiedQuery($contentId:ID!$spaceKey:String$versionOverride:Int$embeddedContentRender:String$limit:Int$useNewContentTopper:Boolean=false$status:[String]){content(id:$contentId version:$versionOverride embeddedContentRender:$embeddedContentRender status:$status){nodes{id type subType title status ...contentAppearancePublishedFragment history{createdDate createdBy{...byLineUserFragment}ownedBy{...byLineUserFragment}lastOwnedBy{...byLineUserFragment}}emojiTitlePublished:properties(key:"emoji-title-published"){nodes{id key value version{number}}}pageTitlePublished:properties(key:"page-title-property-published")@include(if:$useNewContentTopper){nodes{id key value version{number}}}properties(key:"editor"){nodes{id key value}}space{id name homepageId}version{message by{...byLineUserFragment}friendlyWhen when number contentTypeModified}metadata{sourceTemplateEntityId lastModifiedDate frontend{coverPictureWidth@include(if:$useNewContentTopper)}}}}contentContributors(id:$contentId limit:$limit){count isCurrentUserContributor isOwnerContributor nodes{...byLineUserFragment}}space(key:$spaceKey){id theme{themeKey}lookAndFeel{headings{key value}content{header{background backgroundAttachment backgroundBlendMode backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPosition backgroundRepeat backgroundSize borderRadius padding}}}}}${(0, $8sR0p.byLineUserFragment)}${(0, $5byFK.contentAppearancePublishedFragment)}`;

});

parcelRegister("80xNa", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONTRIBUTORS_FETCH_LIMIT", () => $5d488939c8bec967$export$21191b0c00ca25f4);
$parcel$export(module.exports, "CONFLUENCE_EDITION", () => $5d488939c8bec967$export$4b915fb24c39b396);
const $5d488939c8bec967$export$21191b0c00ca25f4 = 4;
const $5d488939c8bec967$export$4b915fb24c39b396 = {
    //copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
    FREE: 'FREE',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD'
};

});

parcelRegister("gaqtW", function(module, exports) {

$parcel$export(module.exports, "LivePagesByLineWithContributorsComponent", () => $3db5129918072e70$export$a6a69f624b6c8259);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $ipPpS = parcelRequire("ipPpS");

var $diswb = parcelRequire("diswb");

var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $6mKj3 = parcelRequire("6mKj3");

var $5zuN8 = parcelRequire("5zuN8");

var $dIouf = parcelRequire("dIouf");

var $6S5EB = parcelRequire("6S5EB");

var $9wGTI = parcelRequire("9wGTI");

var $7om8k = parcelRequire("7om8k");
var $1xCGJ = parcelRequire("1xCGJ");

var $fs6LW = parcelRequire("fs6LW");
var $jJK3p = parcelRequire("jJK3p");

var $7QM6o = parcelRequire("7QM6o");

var $aE7dy = parcelRequire("aE7dy");

var $bnIxr = parcelRequire("bnIxr");

var $bth99 = parcelRequire("bth99");

var $3jwuS = parcelRequire("3jwuS");

var $blyhC = parcelRequire("blyhC");

var $j2moL = parcelRequire("j2moL");

var $dyWO6 = parcelRequire("dyWO6");

var $35Exc = parcelRequire("35Exc");

var $83fWZ = parcelRequire("83fWZ");

var $bNel4 = parcelRequire("bNel4");

var $aKxcs = parcelRequire("aKxcs");

var $6iOCg = parcelRequire("6iOCg");
const $3db5129918072e70$var$bylineAppsStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    font: 'font.body.small',
    display: 'inline'
});
const $3db5129918072e70$export$a6a69f624b6c8259 = /*#__PURE__*/ (0, $gwFzn.memo)(({ contentId: contentId, author: author, owner: owner, createdDate: createdDate, lastModifyUser: lastModifyUser, contributors: contributors, contributorsCount: contributorsCount, isOwnerContributor: isOwnerContributor, lastOwner: lastOwner, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, isKnowledgeBaseSpace: isKnowledgeBaseSpace, viewMode: viewMode, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isExternalShare = (0, $6S5EB.isExternalShareRequest)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { hasApps: hasApps, connectItems: connectItems, forgeItems: forgeItems, forgeError: forgeError } = (0, $blyhC.useByLineApps)(contentId);
    const { data: data } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $5zuN8.EditorContentStateQuery), {
        fetchPolicy: 'cache-first',
        variables: {
            contentId: contentId,
            isDraft: true
        },
        skip: !Boolean(window.__SSR_RENDERED__)
    });
    const getContributorsData = (0, $gwFzn.useMemo)(()=>{
        const arrangedContributors = (0, $83fWZ.getArrangedContributors)({
            owner: owner,
            author: author,
            lastModifier: lastModifyUser,
            contributors: contributors
        });
        const userToAvatarGroupDataItem = (user)=>({
                // Props for <ProfileAvatar>
                isAnonymous: user.isAnonymous,
                userId: user.userId,
                src: user.avatarUrl,
                // Extra props
                name: user.fullName
            });
        return [
            ...arrangedContributors// Actual data for the users we know about
            .map(userToAvatarGroupDataItem),
            // Skeletons for the ones we don't
            ...Array(Math.max(contributorsCount - arrangedContributors.length, 0)).fill(null).map(()=>({
                    src: (0, $dyWO6.png_1x1_n40),
                    name: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $35Exc.StyledNameSkeleton), null)
                }))
        ];
    }, [
        owner,
        author,
        lastModifyUser,
        contributors,
        contributorsCount
    ]);
    const pageOwnerOrFirstContributorData = getContributorsData[0];
    const contributorCountWithoutOwner = contributorsCount - (isOwnerContributor ? 1 : 0);
    const CreatorOrOwnerByline = (0, $gwFzn.useMemo)(()=>{
        if (owner !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1xCGJ.PageOwnershipByline), {
            owner: owner,
            creator: author,
            createdDate: createdDate,
            templateId: null,
            contentId: contentId,
            lastOwner: lastOwner
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "content-header.livepages.by-line.by.expanded",
            defaultMessage: "By {author}",
            values: {
                author: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jJK3p.ProfileLink), {
                    userId: author.userId,
                    fullName: author.fullName,
                    isAnonymous: author.isAnonymous,
                    referralSource: "profilecard"
                })
            }
        });
    }, [
        author,
        owner,
        createdDate,
        contentId,
        lastOwner
    ]);
    const singleLineOwnershipByline = !(0, $9wGTI.fg)('cc_page_experiences_byline_badge_style') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fs6LW.ProfileAvatar), {
        src: pageOwnerOrFirstContributorData.src,
        userId: pageOwnerOrFirstContributorData.userId,
        isAnonymous: pageOwnerOrFirstContributorData.isAnonymous,
        name: pageOwnerOrFirstContributorData.name,
        size: "small",
        testId: "live-pages-byline-owner-or-first-contributor-avatar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $35Exc.StyledAuthorDiv), null, CreatorOrOwnerByline)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7om8k.BadgeStylePageOwnershipByline), {
        owner: owner,
        author: author,
        analyticsSource: "liveDoc",
        contributorCountWithoutOwner: contributorCountWithoutOwner
    });
    const ByLineCommonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, (0, $9wGTI.fg)('cc_page_experiences_byline_classification') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aKxcs.BylineClassification), {
        contentId: contentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $5zuN8.ContentStateStateContainer)
        ]
    }, (contentStateState)=>{
        // view mode users should not be able to edit the content state, so we just render the content state.
        if (viewMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5zuN8.RendererContentState), {
            contentId: contentId,
            hasSeparator: false,
            isDraft: !isLivePage
        });
        // Knowledge space live pages will always show the editable content state component.
        // Other live pages will only show the editable content state component if the content state is already set.
        // This is because a page without a content state is initialized by the ContentStateHoverButton component.
        // SSRd content state will have it's value in gql cache initially instead of the unstated store
        const isSSRRenderedOnLoad = Boolean(data?.singleContent?.contentState) && Boolean(window.__SSR_RENDERED__) && contentStateState.state.shouldRunContentStateEffect;
        if (contentStateState.state.contentState || isKnowledgeBaseSpace || isSSRRenderedOnLoad) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5zuN8.EditorContentState), {
            contentId: contentId,
            contentType: contentType,
            isPublishingContent: isPublishingContent,
            userOffline: userOffline,
            floatingToolbarButtonStyle: {
                alignItems: 'center',
                height: '24px'
            }
        });
        else return null;
    }), // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    isLivePage && (0, $9wGTI.fg)('live_pages_byline_last_updated') && !(0, $9wGTI.fg)('confluence_frontend_object_header') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bNel4.LivePagesByLineLastUpdated), {
        contentId: contentId,
        editorApi: editorApi
    }), (0, $9wGTI.fg)('live_pages_byline_read_time') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bth99.ReadTime), {
        contentId: contentId,
        editorApi: editorApi,
        isInEditor: true
    }), (isLivePage || !isUnpublishedDraft) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bnIxr.AnalyticsByLine), {
        contentId: contentId,
        contentAuthorId: author.userId
    }), (isLivePage || !isUnpublishedDraft) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aE7dy.LivePagesByLineReactions), {
        contentId: contentId,
        spaceId: spaceId || '',
        isDisabled: userOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false),
        isContentCreationPanelOpen: true,
        isSubtle: true,
        contentType: contentType
    }));
    if ((0, $9wGTI.fg)('confluence_frontend_single_line_byline_live_pages')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6iOCg.SingleLineByLine), {
        contentId: contentId,
        contentType: contentType
    }, singleLineOwnershipByline, ByLineCommonContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        direction: "column",
        testId: "live-pages-byline-multi-line"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $35Exc.LivePagesBylineStyledMainDiv), {
        hasFixedHeight: (0, $9wGTI.fg)('cc_page_experiences_live_pages_byline_placeholder')
    }, !(0, $9wGTI.fg)('cc_page_experiences_byline_badge_style') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $35Exc.StyledAvatars), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fs6LW.ProfileAvatar), {
        src: pageOwnerOrFirstContributorData.src,
        userId: pageOwnerOrFirstContributorData.userId,
        isAnonymous: pageOwnerOrFirstContributorData.isAnonymous,
        name: pageOwnerOrFirstContributorData.name,
        size: "small",
        testId: "live-pages-byline-owner-or-first-contributor-avatar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $35Exc.BylineStyledTextDiv), {
        "data-testId": "byline-text-component",
        hasBadgeStylePageOwnerBylineItem: (0, $9wGTI.fg)('cc_page_experiences_byline_badge_style')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        gap: "space.075",
        justifyContent: "center",
        alignItems: "center"
    }, !(0, $9wGTI.fg)('cc_page_experiences_byline_badge_style') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $35Exc.StyledAuthorDiv), null, CreatorOrOwnerByline) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7om8k.BadgeStylePageOwnershipByline), {
        owner: owner,
        author: author,
        analyticsSource: isLivePage ? 'liveDoc' : 'editor',
        contributorCountWithoutOwner: contributorCountWithoutOwner
    }), ByLineCommonContent))), !isExternalShare && hasApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        xcss: $3db5129918072e70$var$bylineAppsStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).ECOSYSTEM
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j2moL.LazyLivePagesByLineApps), {
        contentId: contentId,
        connectItems: connectItems,
        forgeItems: forgeItems,
        forgeError: forgeError,
        showLivePagesExtensionPoints: true
    }))));
});

});
parcelRegister("aE7dy", function(module, exports) {

$parcel$export(module.exports, "LivePagesByLineReactions", () => $06f66a283e23582e$export$37ba4ba009bc421f);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $4FHTF = parcelRequire("4FHTF");

var $2ttXz = parcelRequire("2ttXz");

var $83sfO = parcelRequire("83sfO");

var $3jwuS = parcelRequire("3jwuS");

var $9wGTI = parcelRequire("9wGTI");

var $1NF8X = parcelRequire("1NF8X");

var $6mKj3 = parcelRequire("6mKj3");
const $06f66a283e23582e$var$i18n = (0, $2nPZH.defineMessages)({
    addNew: {
        id: "live-pages-features.byline.reactions.add.new",
        defaultMessage: "Add new"
    },
    addReaction: {
        id: "live-pages-features.byline.reactions.add.reaction",
        defaultMessage: "Add reaction"
    }
});
const $06f66a283e23582e$var$templateSidebarWidth = 320;
const $06f66a283e23582e$var$floatingContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    position: 'fixed',
    justifyContent: 'right',
    bottom: 'space.300',
    right: 'space.100',
    zIndex: 'layer',
    transition: 'left 600ms'
});
const $06f66a283e23582e$var$subtleReactionsFloatingContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'left',
    transition: 'left 600ms',
    marginBottom: 'space.025',
    height: '28px'
});
const $06f66a283e23582e$var$containerStylesWhenPanelOpen = (0, $ecnYn.xcss)({
    paddingRight: 'space.100',
    right: `${$06f66a283e23582e$var$templateSidebarWidth}px`,
    transition: 'right 600ms'
});
const $06f66a283e23582e$var$topMargin = (0, $ecnYn.xcss)({
    marginTop: 'space.025'
});
const $06f66a283e23582e$export$37ba4ba009bc421f = ({ contentId: contentId, spaceId: spaceId, isDisabled: isDisabled = false, isContentCreationPanelOpen: isContentCreationPanelOpen, isSubtle: isSubtle, contentType: contentType })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Used when we want to allow the user to select reactions from the summary view popup
    const customIcon = (0, $9wGTI.fg)('confluence_page_reactions_ga_changes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))), {
        testId: "emoji-add-icon",
        color: "var(--ds-icon-subtle, #626F86)",
        label: formatMessage($06f66a283e23582e$var$i18n.addReaction)
    }) : undefined;
    const reactionPickerText = (0, $9wGTI.fg)('confluence_page_reactions_ga_changes') ? formatMessage($06f66a283e23582e$var$i18n.addNew) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            isSubtle ? $06f66a283e23582e$var$subtleReactionsFloatingContainerStyles : $06f66a283e23582e$var$floatingContainerStyles,
            isContentCreationPanelOpen && $06f66a283e23582e$var$containerStylesWhenPanelOpen,
            $06f66a283e23582e$var$topMargin
        ],
        testId: "live-pages-reactions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1NF8X.ReactionsLoader), {
        contentId: contentId,
        location: contentType === 'blogpost' ? (0, $2ttXz.ReactionLocation).BLOGPOST : (0, $2ttXz.ReactionLocation).PAGE,
        containerId: spaceId,
        containerType: (0, $2ttXz.ReactionContainerType).SPACE,
        contentSubType: isLivePage ? (0, $83sfO.LIVE_PAGE_SUBTYPE) : null,
        summaryViewEnabled: true,
        summaryViewThreshold: 1,
        allowSelectFromSummaryView: (0, $9wGTI.fg)('confluence_page_reactions_ga_changes'),
        useButtonAlignmentStyling: true,
        summaryViewPlacement: "bottom-start",
        hideNoReactionsText: true,
        readOnly: isDisabled,
        isViewOnly: (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && isDisabled,
        isSubtle: isSubtle,
        reactionPickerTriggerIcon: customIcon,
        reactionPickerTriggerText: reactionPickerText,
        useDefaultStyledContainer: true,
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        hidePlaceholder: Boolean((0, window.__SSR_RENDERED__)),
        noRelativeContainer: (0, $9wGTI.fg)('confluence_frontend_single_line_byline_live_pages'),
        noFlexWrap: (0, $9wGTI.fg)('confluence_frontend_single_line_byline_live_pages'),
        hoverableSummaryView: (0, $9wGTI.fg)('confluence_page_reactions_ga_changes')
    }));
};

});
parcelRegister("83sfO", function(module, exports) {

$parcel$export(module.exports, "LIVE_PAGE_SUBTYPE", () => $567f280605647fdf$export$5d4c19aec4201e9);
const $567f280605647fdf$export$5d4c19aec4201e9 = 'live';

});


parcelRegister("bnIxr", function(module, exports) {

$parcel$export(module.exports, "AnalyticsByLine", () => $8e265cb10d523fc8$export$d0aef4d352cf8b14);
$parcel$export(module.exports, "SpaceAnalyticsPageLoader", () => $8e265cb10d523fc8$export$5c0ffde074fc4758);
$parcel$export(module.exports, "PageAnalyticsPageLoader", () => $8e265cb10d523fc8$export$1c22a22c4bc3d8e9);
$parcel$export(module.exports, "SiteAnalyticsPageLoader", () => $8e265cb10d523fc8$export$5d828b79b8aa9d27);
$parcel$export(module.exports, "SitePermissionsPageLoader", () => $8e265cb10d523fc8$export$6dd852c6aabadfda);

var $jmjWc = parcelRequire("jmjWc");

const $8e265cb10d523fc8$export$d0aef4d352cf8b14 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Z8mis",
    name: "AnalyticsByLine",
    loader: async ()=>(await (parcelRequire("j7ACu"))).AnalyticsByLine
});

const $8e265cb10d523fc8$export$5c0ffde074fc4758 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "B2ctB",
    name: "SpaceAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("5CoJF"))).SpaceAnalyticsPage
});

const $8e265cb10d523fc8$export$1c22a22c4bc3d8e9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "peBvZ",
    name: "PageAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("9IOp6"))).PageAnalyticsPage
});

const $8e265cb10d523fc8$export$5d828b79b8aa9d27 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1tHym",
    name: "SiteAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("tZJ8n"))).SiteAnalyticsPage
});

const $8e265cb10d523fc8$export$6dd852c6aabadfda = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "FqJCu",
    name: "SitePermissionsPageLoader",
    loader: async ()=>(await (parcelRequire("jBxHA"))).SitePermissionsPage
});

});
parcelRegister("j7ACu", function(module, exports) {

let $debb13b5e3d2354d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $debb13b5e3d2354d$var$load("KhCwB"),
    $debb13b5e3d2354d$var$load("6c9wI")
]).then(()=>parcelRequire('ffp8s'));

});

parcelRegister("5CoJF", function(module, exports) {

let $4173b0518183f917$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $4173b0518183f917$var$load("jcVNr"),
    $4173b0518183f917$var$load("3VzRy"),
    $4173b0518183f917$var$load("4M8fa"),
    $4173b0518183f917$var$load("mBENc"),
    $4173b0518183f917$var$load("KhCwB"),
    $4173b0518183f917$var$load("hG0Zu"),
    $4173b0518183f917$var$load("kLKm3"),
    $4173b0518183f917$var$load("3TNOq"),
    $4173b0518183f917$var$load("2Fobu"),
    $4173b0518183f917$var$load("7X74w"),
    $4173b0518183f917$var$load("c6MKV"),
    $4173b0518183f917$var$load("gcyau"),
    $4173b0518183f917$var$load("aZinD"),
    $4173b0518183f917$var$load("bYnOS")
]).then(()=>parcelRequire('3EzW0'));

});

parcelRegister("9IOp6", function(module, exports) {

let $713f524be955538a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $713f524be955538a$var$load("gYJBG"),
    $713f524be955538a$var$load("3VzRy"),
    $713f524be955538a$var$load("4M8fa"),
    $713f524be955538a$var$load("mBENc"),
    $713f524be955538a$var$load("ctbEl"),
    $713f524be955538a$var$load("KhCwB"),
    $713f524be955538a$var$load("e08m0"),
    $713f524be955538a$var$load("hG0Zu"),
    $713f524be955538a$var$load("kLKm3"),
    $713f524be955538a$var$load("aJJUY"),
    $713f524be955538a$var$load("3TNOq"),
    $713f524be955538a$var$load("2Fobu"),
    $713f524be955538a$var$load("7X74w"),
    $713f524be955538a$var$load("gcyau"),
    $713f524be955538a$var$load("15APZ"),
    $713f524be955538a$var$load("18vkH"),
    $713f524be955538a$var$load("2w2Fa"),
    $713f524be955538a$var$load("9QvHa"),
    $713f524be955538a$var$load("3ooAX"),
    $713f524be955538a$var$load("4lfDj"),
    $713f524be955538a$var$load("kUAIU"),
    $713f524be955538a$var$load("dTsOE"),
    $713f524be955538a$var$load("2RgZK"),
    $713f524be955538a$var$load("aZinD"),
    $713f524be955538a$var$load("c6MKV"),
    $713f524be955538a$var$load("6sFkE")
]).then(()=>parcelRequire('1T0Cv'));

});

parcelRegister("tZJ8n", function(module, exports) {

let $05a2973d169f7e64$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $05a2973d169f7e64$var$load("gYJBG"),
    $05a2973d169f7e64$var$load("jcVNr"),
    $05a2973d169f7e64$var$load("3VzRy"),
    $05a2973d169f7e64$var$load("4M8fa"),
    $05a2973d169f7e64$var$load("mBENc"),
    $05a2973d169f7e64$var$load("KhCwB"),
    $05a2973d169f7e64$var$load("hG0Zu"),
    $05a2973d169f7e64$var$load("kLKm3"),
    $05a2973d169f7e64$var$load("3TNOq"),
    $05a2973d169f7e64$var$load("2Fobu"),
    $05a2973d169f7e64$var$load("7X74w"),
    $05a2973d169f7e64$var$load("c6MKV"),
    $05a2973d169f7e64$var$load("gcyau"),
    $05a2973d169f7e64$var$load("hLE8r")
]).then(()=>parcelRequire('9Gz8W'));

});

parcelRegister("jBxHA", function(module, exports) {

let $e45b9d8c8bffce01$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e45b9d8c8bffce01$var$load("3VzRy"),
    $e45b9d8c8bffce01$var$load("2sCab")
]).then(()=>parcelRequire('3GuAz'));

});


parcelRegister("bNel4", function(module, exports) {

$parcel$export(module.exports, "LivePagesByLineLastUpdated", () => $dce34ae8b4376c02$export$e4a26074619839f4);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $diswb = parcelRequire("diswb");

var $2jjxD = parcelRequire("2jjxD");

var $inPa6 = parcelRequire("inPa6");

var $6qdjm = parcelRequire("6qdjm");

var $3gadb = parcelRequire("3gadb");

var $dIouf = parcelRequire("dIouf");

var $7Sm4c = parcelRequire("7Sm4c");

var $bQm3c = parcelRequire("bQm3c");

var $6iSKO = parcelRequire("6iSKO");

var $AavAW = parcelRequire("AavAW");
const $dce34ae8b4376c02$var$i18n = (0, $2nPZH.defineMessages)({
    recentFriendlyWhen: {
        id: "content-header.by-line.live-pages.last.updated.friendly.just.now",
        defaultMessage: "Just now"
    },
    tooltipWhen: {
        id: "content-header.by-line.live-pages.last.updated.tooltip",
        defaultMessage: "Last updated: {day} at {time}"
    }
});
const $dce34ae8b4376c02$export$e4a26074619839f4 = /*#__PURE__*/ (0, $gwFzn.memo)(({ contentId: contentId, editorApi: editorApi })=>{
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $6iSKO.ByLineLastUpdatedQuery), {
        variables: {
            contentId: contentId
        },
        notifyOnNetworkStatusChange: true,
        // sets loading to true when refetching, necessary for tooltip
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'cache-and-network' // query is preloaded on SSR, but not for SPA
    });
    const latestVersion = data?.content?.nodes?.[0]?.version;
    // We need version in a state variable separate from query data, in order to set it on debouncedSetRecentVersion
    const [version, setVersion] = (0, $gwFzn.useState)({
        friendlyWhen: latestVersion?.friendlyWhen || null,
        when: latestVersion?.when || null
    });
    const previousRemoteChangeTimeRef = (0, $gwFzn.useRef)(undefined);
    const previousLocalChangeTimeRef = (0, $gwFzn.useRef)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const intl = (0, $dBxQj.default)();
    // Medium dateStyle does not support 'at' combiner, so we're using separate date/time formatters
    const dayFormatter = Intl.DateTimeFormat(locale, {
        dateStyle: 'medium'
    });
    const timeFormatter = Intl.DateTimeFormat(locale, {
        timeStyle: 'short'
    });
    (0, $gwFzn.useEffect)(()=>{
        // Only show the latest version, which could be from the query or from debouncedSetRecentVersion
        if (latestVersion && JSON.stringify(latestVersion) !== JSON.stringify(version) && latestVersion.when && latestVersion.when >= (version?.when ?? '0')) setVersion(latestVersion);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to trigger this on data change
    }, [
        latestVersion
    ]);
    // Fetch that is immediately invoked before the debounced wait period
    // Used on visibility change (when user switches to this tab) and mouseenter
    const debouncedLeadingFetch = (0, $gwFzn.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(refetch, 60000, {
            leading: true,
            trailing: false,
            maxWait: 60000
        }), [
        refetch
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // Fetch last updated time when tab is focused
        const handleVisibilityChange = async ()=>{
            if (document.visibilityState === 'visible') debouncedLeadingFetch(); // Get latest value when user switches back to this tab
        };
        window.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            window.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [
        debouncedLeadingFetch
    ]);
    // After a page edit, we know the last change was very recent, so we directly set the version and skip
    // fetching over the network. We still debounce this to avoid rapid calls and prevent perfromance lag
    // when a user starts typing on very large pages
    const debouncedSetRecentVersion = (0, $gwFzn.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(()=>{
            setVersion({
                friendlyWhen: intl.formatMessage($dce34ae8b4376c02$var$i18n.recentFriendlyWhen),
                when: new Date().toISOString()
            });
        }, 3000), [
        setVersion,
        intl
    ]);
    // Update time stamp to "Just now" on page edit
    (0, $6qdjm.usePluginStateEffect)(editorApi, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>{
        const lastRemoteChangeTime = collabEditState?.initialised?.lastRemoteOrganicBodyChangeAt;
        const lastLocalChangeTime = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        const hasRemoteChanged = lastRemoteChangeTime && lastRemoteChangeTime !== previousRemoteChangeTimeRef.current;
        const hasLocalChanged = lastLocalChangeTime && lastLocalChangeTime !== previousLocalChangeTimeRef.current;
        if (hasRemoteChanged || hasLocalChanged) {
            previousRemoteChangeTimeRef.current = lastRemoteChangeTime;
            previousLocalChangeTimeRef.current = lastLocalChangeTime;
            debouncedSetRecentVersion();
        }
    });
    // Cancel any pending timers on unmount
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            debouncedLeadingFetch.cancel();
            debouncedSetRecentVersion.cancel();
        };
    }, [
        debouncedLeadingFetch,
        debouncedSetRecentVersion
    ]);
    const tooltipContent = (0, $gwFzn.useMemo)(()=>{
        if (loading) return null;
        else if (version?.when) {
            // When time since last update is > 48 hours ago, friendlyWhen will be a date (i.e. Oct 31, 2024)
            // However, user time zone conversion of the friendlyWhen date is not currently working on the BE,
            // which means the localized date in the tooltip can differ from the UTC date in the byline.
            // To fix this discrepancy, for now we'll not show the tooltip for dates > 48 hours
            const date = new Date(version?.when);
            const twoDaysInMillis = 172800000;
            if (Date.now() - date.getTime() > twoDaysInMillis) return null;
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                ...$dce34ae8b4376c02$var$i18n.tooltipWhen,
                values: {
                    day: dayFormatter.format(date),
                    time: timeFormatter.format(date)
                }
            });
        }
    }, [
        loading,
        version?.when,
        dayFormatter,
        timeFormatter
    ]);
    if (error) {
        if ((0, $dIouf.isUnauthorizedError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return null;
        } else // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
        // so returning empty `<ErrorDisplay>` here.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
            error: error
        });
    }
    const handleTooltipShow = ()=>{
        debouncedLeadingFetch();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'LivePagesByLineLastUpdated',
                action: 'displayed',
                actionSubject: 'tooltip',
                actionSubjectId: 'bylineLastUpdate',
                attributes: {
                    contentId: contentId,
                    isLivePage: true
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: tooltipContent,
        onShow: handleTooltipShow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $AavAW.ByLineLastUpdatedCompact), {
        version: version,
        loading: loading
    }));
});

});




parcelRegister("eZFA1", function(module, exports) {

$parcel$export(module.exports, "GrantAccessDialogLoaderQuery", () => $4ab52410a046c365$export$1cf432ea3a028ecc);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $4ab52410a046c365$export$1cf432ea3a028ecc = (0, $d2LG0.default)`query GrantAccessDialogLoaderQuery($contentId:ID!$accountId:ID!){singleContent(id:$contentId){id title}user:confluence_atlassianUser(id:$accountId){id displayName photos{value isPrimary}}}`;

});

parcelRegister("g3p2i", function(module, exports) {

$parcel$export(module.exports, "SitePermissionType", () => $fc6a2e7c662c45f6$export$8995abb8169b2cb8);
$parcel$export(module.exports, "SitePermissionTypeFilter", () => $fc6a2e7c662c45f6$export$3347a7c058a0368a);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $fc6a2e7c662c45f6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $fc6a2e7c662c45f6$export$3347a7c058a0368a = /*#__PURE__*/ function(SitePermissionTypeFilter) {
    SitePermissionTypeFilter["ALL"] = "ALL";
    SitePermissionTypeFilter["EXTERNALCOLLABORATOR"] = "EXTERNALCOLLABORATOR";
    SitePermissionTypeFilter["NONE"] = "NONE";
    return SitePermissionTypeFilter;
}({});

});

parcelRegister("hpRYU", function(module, exports) {

$parcel$export(module.exports, "UserAndGroupSearchPicker", () => $4cbf051190fe8573$export$ca514d5352bb0171);
/* UserAndGroupSearchPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $d2LG0 = parcelRequire("d2LG0");

var $j1Ss3 = parcelRequire("j1Ss3");

var $4jR19 = parcelRequire("4jR19");

var $kSKAi = parcelRequire("kSKAi");

var $7rus4 = parcelRequire("7rus4");

var $bQm3c = parcelRequire("bQm3c");

var $dIouf = parcelRequire("dIouf");

var $kr1Wj = parcelRequire("kr1Wj");

var $7Sm4c = parcelRequire("7Sm4c");

var $jjoF2 = parcelRequire("jjoF2");

var $g3p2i = parcelRequire("g3p2i");
const $4cbf051190fe8573$var$MIN_SEARCH_LENGTH = 2;
const $4cbf051190fe8573$export$1434adfffc17371d = 200;
function $4cbf051190fe8573$export$e11674744930cd15(error) {
    if ('statusCode' in error && error['statusCode'] === 403 || error.message?.includes('403') || error.message?.includes('not allowed')) return true;
    return false;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cbf051190fe8573$var$DefaultWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1f1u1ylp _4g2iv77o _pfyjv77o",
            __cmplp.className
        ])
    });
});
const $4cbf051190fe8573$export$fd4159eb872f73c6 = ({ appearance: appearance, fieldId: fieldId, client: client, isMulti: isMulti, includeGroup: includeGroup, onSelect: onSelect, onChange: onChange, onClear: onClear, onFocus: onFocus, onBlur: onBlur, onOpen: onOpen, onClose: onClose, onInputChange: onInputChange, onKeyDown: onKeyDown, filterSearchResults: filterSearchResults, smartFilterOptions: smartFilterOptions, value: value, defaultValue: defaultValue, noOptionsMessage: noOptionsMessage, addMoreMessage: addMoreMessage, menuPortalTarget: menuPortalTarget, autoFocus: autoFocus, width: width, maxPickerHeight: maxPickerHeight, smart: smart, styles: styles, placeholder: placeholder, sitePermissionTypeFilter: sitePermissionTypeFilter = (0, $g3p2i.SitePermissionTypeFilter).NONE, allowEmail: allowEmail, includeTeams: includeTeams, menuPosition: menuPosition, customInclusion: customInclusion = [], ariaLabel: ariaLabel, ariaDescribedBy: ariaDescribedBy, role: role, isDisabled: isDisabled = false, isLoading: isLoading = false, bootstrapOptions: bootstrapOptions = [], inputId: inputId, withUsers: withUsers = true, Wrapper: Wrapper = $4cbf051190fe8573$var$DefaultWrapper, header: header, open: open, userpickerDescribedbyId: userpickerDescribedbyId })=>{
    const [error, setError] = (0, $gwFzn.useState)(undefined);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { loading: searchPickerLoading, data: searchPickerData } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query UserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}`);
    const handleError = (searchError)=>{
        if (searchError) {
            setError(searchError); // mark error as handled so we don't have ui unhandled errors
            (0, $7Sm4c.markErrorAsHandled)(searchError);
        }
    };
    const promiseOptions = (searchTerm)=>!searchTerm || searchTerm.length < $4cbf051190fe8573$var$MIN_SEARCH_LENGTH ? [] : (0, $jjoF2.userGroupSearchPromise)({
            searchTerm: searchTerm,
            client: client,
            includeGroup: includeGroup,
            customInclusion: customInclusion,
            setError: setError,
            filterResults: filterSearchResults,
            sitePermissionTypeFilter: sitePermissionTypeFilter,
            withUsers: withUsers
        });
    const searchErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.search.error" // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        ,
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "Sorry, we're having trouble loading search results right now."
    });
    const permissionErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.permission.error" // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        ,
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We couldn't find any results because you don't have permission to search the user directory."
    }); // TODO: <UserPicker> expects `noOptionsMessage` to return string | null
    // but this callback returns JSX.Element | string | null, so error message must be string.
    const emptyResultsMessage = (input)=>{
        if (error) {
            if ($4cbf051190fe8573$export$e11674744930cd15(error)) return permissionErrorMessage;
            return searchErrorMessage;
        } else if (typeof noOptionsMessage === 'function') return noOptionsMessage(input);
        return noOptionsMessage;
    };
    const isEntitledExternalCollaboration = (0, $kr1Wj.getExternalCollaboratorEntitlementFromQuery)(searchPickerData) ?? false;
    const finalPlaceholder = placeholder || (includeGroup ? allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.placeholder.text.users.groups.and.email",
        defaultMessage: "Add people by name, email, or group"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.placeholder.text.users.and.groups" // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        ,
        defaultMessage: "Type a user name or group"
    }) : allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.placeholder.text.users.and.email",
        defaultMessage: "Add people, emails"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.placeholder.text.users" // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        ,
        defaultMessage: "Type a user name"
    }));
    const commonProps = {
        appearance: appearance,
        placeholder: finalPlaceholder,
        addMoreMessage: addMoreMessage,
        isMulti: isMulti,
        defaultValue: defaultValue,
        fieldId: fieldId,
        menuPortalTarget: menuPortalTarget,
        noOptionsMessage: emptyResultsMessage,
        onChange: onChange,
        onClear: onClear,
        onFocus: onFocus,
        onOpen: onOpen,
        onClose: onClose,
        onInputChange: onInputChange,
        onSelection: onSelect,
        value: value,
        width: width,
        maxPickerHeight: maxPickerHeight,
        allowEmail: allowEmail,
        styles: styles,
        menuPosition: menuPosition,
        isDisabled: isDisabled,
        inputId: inputId,
        withUsers: withUsers,
        header: header,
        open: open,
        'aria-labelledby': `react-select-${fieldId}-placeholder`,
        'aria-describedby': userpickerDescribedbyId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Wrapper, {
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedBy,
        role: role
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }) : null, !smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kSKAi.UserPicker), {
        ...commonProps,
        inputId: inputId,
        autoFocus: autoFocus,
        loadOptions: promiseOptions,
        onBlur: onBlur,
        isLoading: isLoading,
        appearance: appearance
    }), smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7rus4.default), {
        ...commonProps,
        inputId: inputId,
        debounceTime: $4cbf051190fe8573$export$1434adfffc17371d,
        includeGroups: includeGroup,
        isLoading: searchPickerLoading || isLoading,
        maxOptions: 60,
        onError: handleError,
        filterOptions: smartFilterOptions,
        productAttributes: {
            isEntitledConfluenceExternalCollaborator: isEntitledExternalCollaboration
        },
        principalId: "context" // infer principal ID from UCT
        ,
        productKey: "confluence" // eslint-disable-next-line jsx-a11y/no-autofocus
        ,
        autoFocus: autoFocus,
        siteId: cloudId,
        orgId: orgId,
        includeTeams: includeTeams,
        bootstrapOptions: bootstrapOptions,
        onBlur: onBlur,
        onKeyDown: onKeyDown
    }));
};
const $4cbf051190fe8573$export$ca514d5352bb0171 = (0, $j1Ss3.withApollo)($4cbf051190fe8573$export$fd4159eb872f73c6);

});
parcelRegister("jjoF2", function(module, exports) {

$parcel$export(module.exports, "userGroupSearchPromise", () => $9d3a4572140e810a$export$c139484855007019);

var $9fywD = parcelRequire("9fywD");

var $11dKl = parcelRequire("11dKl");

var $9eE57 = parcelRequire("9eE57");

var $g3p2i = parcelRequire("g3p2i");

var $6RGMW = parcelRequire("6RGMW");
const $9d3a4572140e810a$export$c139484855007019 = ({ searchTerm: searchTerm, client: client, includeGroup: includeGroup, customInclusion: customInclusion, setError: setError, sitePermissionTypeFilter: sitePermissionTypeFilter, filterResults: filterResults, withUsers: withUsers })=>{
    const subject = 'userAndGroupSearchQuery';
    (0, $9eE57.perfMarkStart)({
        subject: subject
    });
    return client.query({
        query: (0, $6RGMW.UserAndGroupSearchQuery),
        variables: {
            withGroups: includeGroup,
            searchTerm: searchTerm,
            sitePermissionTypeFilter: sitePermissionTypeFilter,
            withUsers: withUsers
        }
    }).then(({ data: data })=>{
        const { users: users = [], groups: groups = [] } = data.userGroupSearch;
        const userList = users.map((item)=>({
                id: `user-${item.accountId}`,
                name: item.displayName,
                extra: item,
                type: 'user',
                avatarUrl: item.profilePicture ? item.profilePicture.path : '',
                lozenge: item.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $9fywD.ExternalUserLozengeProps) : null
            }));
        const groupList = groups.map((item)=>({
                id: `group-${item.id}`,
                name: item.name,
                type: 'group',
                extra: item,
                lozenge: item.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $11dKl.ExternalGroupLozengeProps) : null
            }));
        const customInclusionList = [];
        const cleanedSearchTerm = searchTerm.replace(/\s/g, '').toLowerCase();
        customInclusion.forEach((inclusionObj)=>{
            Object.keys(inclusionObj).forEach((key)=>{
                if (key.toLowerCase().startsWith(cleanedSearchTerm)) customInclusionList.push(inclusionObj[key]);
            });
        });
        const usersGroupsAndAccessClasses = [
            ...customInclusionList,
            ...userList,
            ...groupList
        ];
        (0, $9eE57.perfMarkEnd)({
            subject: subject
        });
        return filterResults ? usersGroupsAndAccessClasses.filter(filterResults) : usersGroupsAndAccessClasses;
    }).catch((error)=>{
        setError(error);
        return [];
    });
};

});
parcelRegister("11dKl", function(module, exports) {

$parcel$export(module.exports, "ExternalGroupLozengeProps", () => $f9006b515271a00f$export$fef38ba78dbe85a6);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $aIk0I = parcelRequire("aIk0I");

var $3gadb = parcelRequire("3gadb");
const $f9006b515271a00f$var$i18n = (0, $2nPZH.defineMessages)({
    externalGroupLozengeText: {
        id: "external-collab-ui.group-guest-lozenge",
        defaultMessage: "Guest"
    },
    externalGroupTooltip: {
        id: "external-collab-ui.group-guest-lozenge.tooltip",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
const $f9006b515271a00f$export$fef38ba78dbe85a6 = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $f9006b515271a00f$var$i18n.externalGroupTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $f9006b515271a00f$var$i18n.externalGroupLozengeText)),
    appearance: 'new',
    isBold: false
};
const $f9006b515271a00f$export$e899659b70340bcf = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $f9006b515271a00f$export$fef38ba78dbe85a6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aIk0I.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};

});

parcelRegister("6RGMW", function(module, exports) {

$parcel$export(module.exports, "UserAndGroupSearchQuery", () => $88fbd0e78227b736$export$9eed0d08b5194ae7);

var $d2LG0 = parcelRequire("d2LG0");
const $88fbd0e78227b736$export$9eed0d08b5194ae7 = (0, $d2LG0.default)`query UserAndGroupSearchQuery($searchTerm:String!$maxResults:Int=50$withGroups:Boolean=true$withUsers:Boolean=true$sitePermissionTypeFilter:SitePermissionTypeFilter=NONE){userGroupSearch(query:$searchTerm maxResults:$maxResults sitePermissionTypeFilter:$sitePermissionTypeFilter){users@include(if:$withUsers){type displayName permissionType profilePicture{path}...on User{accountId}...on KnownUser{accountId}}groups@include(if:$withGroups){id name permissionType}}}`;

});



parcelRegister("62BfR", function(module, exports) {

$parcel$export(module.exports, "replaceAtlTokenPlaceholder", () => $d97d2e8640b15cc8$export$87286345b169ae5e);
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}

});

parcelRegister("bVAxT", function(module, exports) {

$parcel$export(module.exports, "RestrictionsDialogStateContainer", () => $20c3e8ab10e63e24$export$f91385b453474810);
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $ipPpS = parcelRequire("ipPpS");
class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $ipPpS.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}

});

parcelRegister("b1HmN", function(module, exports) {

$parcel$export(module.exports, "LoadableChangeEditionNotificationDialog", () => $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6);

var $jmjWc = parcelRequire("jmjWc");

const $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ishvT",
    name: "LoadableChangeEditionNotificationDialog",
    loader: async ()=>(await (parcelRequire("2uk7P"))).ChangeEditionNotificationDialog
});

});
parcelRegister("2uk7P", function(module, exports) {

let $1cfdfe909af8de2b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1cfdfe909af8de2b$var$load("kSVGa").then(()=>parcelRequire('5BDEU'));

});


parcelRegister("tvI67", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::552918135e976d59647ada829319b3a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $058b4e8b1f67a9a7$var$_react = $058b4e8b1f67a9a7$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $058b4e8b1f67a9a7$var$_baseNew = $058b4e8b1f67a9a7$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $058b4e8b1f67a9a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Apps".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding or viewing apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $058b4e8b1f67a9a7$var$AppsIcon = (props)=>/*#__PURE__*/ $058b4e8b1f67a9a7$var$_react.default.createElement($058b4e8b1f67a9a7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM1 11a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm8.25.75V9h1.5v2.25H15v1.5h-2.25V15h-1.5v-2.25H9v-1.5z" clip-rule="evenodd"/>`
    }, props));
$058b4e8b1f67a9a7$var$AppsIcon.displayName = 'AppsIcon';
var $058b4e8b1f67a9a7$var$_default = module.exports.default = $058b4e8b1f67a9a7$var$AppsIcon;

});

parcelRegister("5u6LZ", function(module, exports) {

$parcel$export(module.exports, "GrantAccessDialogLoader", () => $11d9bf397902be9d$export$238288686fd365c4);

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $dIouf = parcelRequire("dIouf");

var $jmjWc = parcelRequire("jmjWc");

var $eZFA1 = parcelRequire("eZFA1");

const $11d9bf397902be9d$export$cc070c4b76bfe85d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "5ag_g",
    name: "GrantAccessDialogPaint",
    loader: async ()=>(await (parcelRequire("82WSo"))).GrantAccessDialog
});

const $11d9bf397902be9d$export$238288686fd365c4 = ({ contentId: contentId, accountId: accountId, shouldSSRGrantAccessRestrictions: shouldSSRGrantAccessRestrictions, buttonPlaceholder: buttonPlaceholder, ...props })=>{
    const GrantAccessDialog = (0, $jmjWc.LoadableLazy)({
        __loadable_id__: "o997N",
        name: "GrantAccessDialog",
        loader: async ()=>(await (parcelRequire("82WSo"))).GrantAccessDialog,
        loading: ()=>buttonPlaceholder
    });
    const shouldPreloadGrantAccess = shouldSSRGrantAccessRestrictions && window.__SSR_RENDERED__;
    const { data: data, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $eZFA1.GrantAccessDialogLoaderQuery), {
        variables: {
            contentId: contentId || '',
            accountId: accountId
        },
        skip: !contentId || !accountId,
        fetchPolicy: shouldPreloadGrantAccess ? 'cache-first' : 'cache-and-network'
    });
    let profilePhoto = '';
    const photos = data?.user?.photos;
    if (photos?.length) {
        const primary = photos.find((photo)=>photo?.isPrimary);
        const foundPhoto = primary ? primary.value : photos[0]?.value;
        profilePhoto = foundPhoto || '';
    }
    const Component = shouldSSRGrantAccessRestrictions ? $11d9bf397902be9d$export$cc070c4b76bfe85d : GrantAccessDialog;
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    });
    else if (!contentId || !data?.user) // If user is not recognized or we have no target contentId, render just the children.
    // User is identified via URL params and it would be easy to pass invalid data.
    // Note: must render the children, as this is how restrictions button is displayed
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
        contentId: contentId,
        accountId: accountId,
        contentTitle: data?.singleContent?.title || '',
        displayName: data?.user?.displayName || '',
        profilePhoto: profilePhoto,
        ...props
    });
};

});
parcelRegister("82WSo", function(module, exports) {

let $5dbc2e39f3f76c10$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $5dbc2e39f3f76c10$var$load("h4Nf7"),
    $5dbc2e39f3f76c10$var$load("aZinD"),
    $5dbc2e39f3f76c10$var$load("f96v0"),
    $5dbc2e39f3f76c10$var$load("ev7SX"),
    $5dbc2e39f3f76c10$var$load("5tHTv"),
    $5dbc2e39f3f76c10$var$load("c6MKV"),
    $5dbc2e39f3f76c10$var$load("4fCJZ"),
    $5dbc2e39f3f76c10$var$load("4aLlP"),
    $5dbc2e39f3f76c10$var$load("9PeA0")
]).then(()=>parcelRequire('3aGPB'));

});


parcelRegister("8RR7m", function(module, exports) {

$parcel$export(module.exports, "GrantAccessFlagLoader", () => $1756d5d44ec15fad$export$a83249587a24be5);

var $jmjWc = parcelRequire("jmjWc");

const $1756d5d44ec15fad$export$a83249587a24be5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "960Da",
    name: "GrantAccessFlagLoader",
    loader: async ()=>(await (parcelRequire("Ja0U0"))).GrantAccessFlag
});

});
parcelRegister("Ja0U0", function(module, exports) {

let $087bf891360ed6a1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $087bf891360ed6a1$var$load("h4Nf7"),
    $087bf891360ed6a1$var$load("aZinD"),
    $087bf891360ed6a1$var$load("f96v0"),
    $087bf891360ed6a1$var$load("ev7SX"),
    $087bf891360ed6a1$var$load("5tHTv"),
    $087bf891360ed6a1$var$load("c6MKV"),
    $087bf891360ed6a1$var$load("4fCJZ"),
    $087bf891360ed6a1$var$load("4aLlP"),
    $087bf891360ed6a1$var$load("4mWJk")
]).then(()=>parcelRequire('4Cd45'));

});


parcelRegister("cSVAY", function(module, exports) {

$parcel$export(module.exports, "RestrictionsButtonLoaderPaint", () => $c09757da0c891efc$export$758fc7bfe6cba448);
$parcel$export(module.exports, "RestrictionsButtonLoaderAfterPaint", () => $c09757da0c891efc$export$92f59ae572209281);

var $jmjWc = parcelRequire("jmjWc");

var $eE3dj = parcelRequire("eE3dj");

var $fkOJz = parcelRequire("fkOJz");

const $c09757da0c891efc$export$758fc7bfe6cba448 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "langk",
    name: "RestrictionsButtonLoaderPaint",
    loader: async ()=>(await (parcelRequire("9WDNr"))).RestrictionsButton,
    loading: (0, $fkOJz.RestrictionsButtonLoading)
});

const $c09757da0c891efc$export$92f59ae572209281 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZXc7l",
    name: "RestrictionsButtonLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("9WDNr"))).RestrictionsButton,
    loading: (0, $eE3dj.RestrictionsButtonPlaceholder)
});

});
parcelRegister("eE3dj", function(module, exports) {

$parcel$export(module.exports, "RestrictionsButtonPlaceholder", () => $cb1652ec96a3881c$export$f7c9f842c83767d4);

var $gwFzn = parcelRequire("gwFzn");
function $cb1652ec96a3881c$export$f7c9f842c83767d4() {
    // The RestrictionsDialog will be positioned based on the initial dimensions of
    // RestrictionsButton, so we need to render a placeholder instead of `null`
    // This placeholder is also used in SSR.
    // All the place that is waiting for data in restrictions package should use this placeholder instead of null.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "restrictions-button-placeholder",
        "data-test-id": "restrictions-button-placeholder",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: 32,
            height: 32
        }
    });
}

});

parcelRegister("fkOJz", function(module, exports) {

$parcel$export(module.exports, "RestrictionsButtonLoading", () => $560660f3777cb1ae$export$3375d726052961a6);

var $gwFzn = parcelRequire("gwFzn");

var $j8UzL = parcelRequire("j8UzL");

var $eE3dj = parcelRequire("eE3dj");
const $560660f3777cb1ae$var$checkForSSRRestrictionsButtonClicked = ()=>{
    return Boolean(window.__SSR_EVENTS_CAPTURE__?.restrictionsButton);
};
const $560660f3777cb1ae$export$3375d726052961a6 = ()=>{
    return $560660f3777cb1ae$var$checkForSSRRestrictionsButtonClicked() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j8UzL.SSRActionLoadingSpinner), {
        spinnerId: "restrictions-loading-spinner",
        actionType: "restrictionsButton"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
};

});

parcelRegister("9WDNr", function(module, exports) {

let $73d8669703d89938$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $73d8669703d89938$var$load("bfhXH").then(()=>parcelRequire('l5Yc7'));

});


parcelRegister("h1ewt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25e57ba6be3183cfa1e359a1a5374e32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c63dcb99536cc850$var$_react = $c63dcb99536cc850$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $c63dcb99536cc850$var$_baseNew = $c63dcb99536cc850$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c63dcb99536cc850$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c63dcb99536cc850$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $c63dcb99536cc850$var$_react.default.createElement($c63dcb99536cc850$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$c63dcb99536cc850$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $c63dcb99536cc850$var$_default = module.exports.default = $c63dcb99536cc850$var$LockUnlockedIcon;

});

parcelRegister("dO5HR", function(module, exports) {

$parcel$export(module.exports, "InspectPermissionsDialog", () => $e05d6d01b1afcacd$export$44ec82a0a8c60a0e);
$parcel$export(module.exports, "InspectPermissionsEntryPoint", () => $e05d6d01b1afcacd$export$49d28052e29cecf7);

var $jmjWc = parcelRequire("jmjWc");


const $e05d6d01b1afcacd$export$44ec82a0a8c60a0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "X2r4g",
    name: "InspectPermissionsDialog",
    loader: async ()=>(await (parcelRequire("fteO4"))).InspectPermissionsDialog
});

const $e05d6d01b1afcacd$export$49d28052e29cecf7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "_PpYB",
    name: "InspectPermissionsEntryPoint",
    loader: async ()=>(await (parcelRequire("fnRSC"))).InspectPermissionsEntryPoint
});

});
parcelRegister("fteO4", function(module, exports) {

let $b4350cbfddd87ee1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b4350cbfddd87ee1$var$load("14XOE"),
    $b4350cbfddd87ee1$var$load("77pyi"),
    $b4350cbfddd87ee1$var$load("7rEYM"),
    $b4350cbfddd87ee1$var$load("f96v0"),
    $b4350cbfddd87ee1$var$load("ev7SX"),
    $b4350cbfddd87ee1$var$load("gQSWJ"),
    $b4350cbfddd87ee1$var$load("5tHTv"),
    $b4350cbfddd87ee1$var$load("c6MKV"),
    $b4350cbfddd87ee1$var$load("dTsOE"),
    $b4350cbfddd87ee1$var$load("4aLlP"),
    $b4350cbfddd87ee1$var$load("aZinD"),
    $b4350cbfddd87ee1$var$load("85liN")
]).then(()=>parcelRequire('jl66H'));

});

parcelRegister("fnRSC", function(module, exports) {

let $b332cc68e14cb990$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b332cc68e14cb990$var$load("7rEYM"),
    $b332cc68e14cb990$var$load("69XGw")
]).then(()=>parcelRequire('lJ0CS'));

});


parcelRegister("6UqI3", function(module, exports) {

$parcel$export(module.exports, "getSpaceType", () => $a3c7cd489159fe33$export$28eddf802cd184f7);
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};

});

parcelRegister("3P1RK", function(module, exports) {

$parcel$export(module.exports, "SpacePermissionsTabKey", () => $4a56ff9e2636e665$export$ad59ff7dc414850a);
$parcel$export(module.exports, "SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP", () => $4a56ff9e2636e665$export$d4f1d7ffc41e2d29);

var $fHoxN = parcelRequire("fHoxN");
var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};

});
parcelRegister("fHoxN", function(module, exports) {

$parcel$export(module.exports, "PermissionDisplayType", () => $8a20bb30841ead37$export$f1a726cdbae0d72a);
$parcel$export(module.exports, "SpacePermissionType", () => $8a20bb30841ead37$export$a99f5dae9c149910);
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});

});


parcelRegister("8fGsJ", function(module, exports) {

$parcel$export(module.exports, "getContentRestrictions", () => $69c6be5ab264f19a$export$ea5292b0643714e2);
$parcel$export(module.exports, "getPrincipalsAndRoles", () => $69c6be5ab264f19a$export$9910d0d832defd77);
$parcel$export(module.exports, "getGeneralAccessLevel", () => $69c6be5ab264f19a$export$348a31f6b2aa49f4);
$parcel$export(module.exports, "getKnownErrors", () => $69c6be5ab264f19a$export$9bc75062b1d89a4d);
function $69c6be5ab264f19a$export$ea5292b0643714e2(restrictions, currentUser) {
    const readAndUpdateLists = $69c6be5ab264f19a$var$convertRestrictionsObject(restrictions);
    const { groupCount: groupCount, principals: principals, currentUserHasAccess: currentUserHasAccess } = $69c6be5ab264f19a$export$9910d0d832defd77(readAndUpdateLists, currentUser);
    return {
        generalAccessLevel: $69c6be5ab264f19a$export$348a31f6b2aa49f4(readAndUpdateLists),
        principals: principals,
        groupCount: groupCount,
        currentUserHasAccess: currentUserHasAccess
    };
}
/**
 * Converts the 'read' and 'update' structures from the query data into their
 * structural equivalents but using our own Principal
 */ function $69c6be5ab264f19a$var$convertRestrictionsObject(source) {
    const ret = {
        read: {
            users: [],
            groups: []
        },
        update: {
            users: [],
            groups: []
        }
    };
    const { read: read, update: update } = source;
    if (read) $69c6be5ab264f19a$var$convertUsersAndGroups(read, ret.read);
    if (update) $69c6be5ab264f19a$var$convertUsersAndGroups(update, ret.update);
    return ret;
}
/**
 * Iterates through the users and groups nodes of query data, converting
 * entries into Principal format, and pushing them to accumulators
 */ function $69c6be5ab264f19a$var$convertUsersAndGroups(source, { users: users, groups: groups }) {
    const { restrictions: restrictions } = source;
    if (restrictions) {
        const { userWithRestrictions: userWithRestrictions, group: group } = restrictions;
        if (userWithRestrictions) $69c6be5ab264f19a$var$pushUserNodes(userWithRestrictions, users);
        if (group) $69c6be5ab264f19a$var$pushGroupNodes(group, groups);
    }
}
function $69c6be5ab264f19a$export$348a31f6b2aa49f4({ read: { groups: readGroups, users: readUsers }, update: { groups: updateGroups, users: updateUsers } }) {
    const hasViewPrincipals = readGroups.length + readUsers.length > 0;
    const hasEditPrincipals = updateGroups.length + updateUsers.length > 0;
    if (hasViewPrincipals) return 'restricted';
    if (hasEditPrincipals) return 'open-can-view';
    return 'open-can-edit';
}
function $69c6be5ab264f19a$export$9910d0d832defd77({ read: read, update: update }, currentUser) {
    const map = new Map();
    const addToMapWithRole = (principals, role)=>principals.forEach((principal)=>map.set(principal.id, {
                role: role,
                principal: principal
            }));
    // Initially, populate the map with viewers
    addToMapWithRole([
        ...read.users,
        ...read.groups
    ], 'can-view');
    // Do another pass for the editors, potentially overwriting entries set in the
    // first pass, with their edit role
    addToMapWithRole([
        ...update.users,
        ...update.groups
    ], 'can-edit');
    // Convert the map to a PrincipalAndRole array, and sort by name
    const unsortedArray = Array.from(map).map(([, principalAndRole])=>principalAndRole);
    const groupCount = unsortedArray.reduce((count, { principal: principal })=>{
        if (principal.type === 'group') count++;
        return count;
    }, 0);
    const currentUserHasAccess = unsortedArray.some(({ principal: principal })=>principal.id === currentUser.id);
    return {
        principals: Array.from(map).map(([, principalAndRole])=>principalAndRole).sort(({ principal: { name: a } }, { principal: { name: b } })=>{
            if (a === b) return 0;
            else if (a > b) return 1;
            return -1;
        }),
        currentUserHasAccess: currentUserHasAccess,
        groupCount: groupCount
    };
}
/**
 * Converts groups from query format to Principal format, and pushes them to an accumulator
 */ function $69c6be5ab264f19a$var$pushGroupNodes(source, dest) {
    const { nodes: nodes } = source;
    if (nodes) for (const node of nodes){
        if (!node) continue;
        dest.push({
            type: 'group',
            id: node.id || '',
            name: node.name || ''
        });
    }
}
/**
 * Converts users from query format to Principal format, and pushes them to an accumulator
 */ function $69c6be5ab264f19a$var$pushUserNodes(source, dest) {
    const { nodes: nodes } = source;
    if (nodes) for (const node of nodes){
        if (!node) continue;
        /**
			 * TODO: there are some fields we were querying for in the Restrictions
			 * dialog, but not using here (yet):
			 * • type
			 */ dest.push({
            type: 'user',
            id: node.accountId || '',
            name: node.displayName || '',
            avatarUrl: node.profilePicture?.path || '',
            email: node.email || '',
            knownErrors: $69c6be5ab264f19a$export$9bc75062b1d89a4d(node),
            sitePermissionType: node.permissionType || ''
        });
    }
}
function $69c6be5ab264f19a$export$9bc75062b1d89a4d(node) {
    const { restrictingContent: restrictingContent, hasSpaceEditPermission: hasSpaceEditPermission, hasSpaceViewPermission: hasSpaceViewPermission } = node;
    if (hasSpaceViewPermission === false) return {
        accessWarning: 'space-view-access-warning',
        parentLink: null
    };
    if (restrictingContent) return {
        accessWarning: 'parent-access-warning',
        parentLink: {
            webui: restrictingContent.links?.webui,
            base: restrictingContent.links?.base
        }
    };
    // TODO: Implement a check for the principal's current access level.
    // If the access level is 'view', it's not relevant.
    // If the access level is 'edit', it is relevant.
    if (hasSpaceEditPermission === false) return {
        accessWarning: 'space-edit-access-warning',
        parentLink: null
    };
    return undefined;
}

});

parcelRegister("s1iYf", function(module, exports) {

$parcel$export(module.exports, "WorldGreenDotGlyph", () => $2033212600114d4d$export$fad5f226cecfdfbf);

var $gwFzn = parcelRequire("gwFzn");
const $2033212600114d4d$export$fad5f226cecfdfbf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.8837 13.367C19.9601 12.9228 20 12.466 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C12.466 20 12.9228 19.9601 13.367 19.8837C13.1304 19.3023 13 18.6664 13 18C13 17.8036 13.0113 17.6099 13.0333 17.4195C12.9034 17.622 12.7713 17.7875 12.6409 17.9161C12.3763 18.1772 12.1606 18.25 12 18.25C11.8394 18.25 11.6237 18.1772 11.3591 17.9161C11.0913 17.6518 10.8157 17.2321 10.568 16.6543C10.1416 15.6593 9.84191 14.2977 9.76783 12.75L14.2322 12.75C14.1914 13.6024 14.0821 14.3983 13.921 15.1076C14.3759 14.4673 14.9778 13.9386 15.6776 13.5709C15.7028 13.3018 15.7216 13.0278 15.7337 12.75H18.4572C18.4469 12.8397 18.4348 12.9289 18.4208 13.0175C18.9344 13.0603 19.426 13.1807 19.8837 13.367ZM10.568 7.34569C10.1416 8.34074 9.84191 9.70234 9.76783 11.25L14.2322 11.25C14.1581 9.70234 13.8584 8.34074 13.432 7.34569C13.1843 6.7679 12.9087 6.34823 12.6409 6.08391C12.3763 5.82276 12.1606 5.75 12 5.75C11.8394 5.75 11.6237 5.82276 11.3591 6.08391C11.0913 6.34823 10.8157 6.7679 10.568 7.34569ZM15.7337 11.25L18.4572 11.25C18.1804 8.84094 16.5866 6.83252 14.4139 5.96299C14.5588 6.20973 14.6909 6.47541 14.8107 6.75481C15.328 7.96182 15.6587 9.53144 15.7337 11.25ZM5.5428 11.25L8.26628 11.25C8.34127 9.53144 8.67203 7.96182 9.18932 6.75481C9.30907 6.47541 9.44124 6.20974 9.58609 5.96299C7.41342 6.83252 5.81958 8.84094 5.5428 11.25ZM8.26628 12.75H5.5428C5.81958 15.1591 7.41342 17.1675 9.58609 18.037C9.44124 17.7903 9.30906 17.5246 9.18932 17.2452C8.67203 16.0382 8.34127 14.4686 8.26628 12.75Z",
        fill: "var(--ds-text-subtle, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("circle", {
        cx: "18",
        cy: "18",
        r: "3",
        fill: "var(--ds-icon-accent-green, #22A06B)"
    }));

});

parcelRegister("gKilh", function(module, exports) {

$parcel$export(module.exports, "dataToQueriesState", () => $604ab07d7457ad5e$export$1864618d14e03dd7);
$parcel$export(module.exports, "canSetRestrictions", () => $604ab07d7457ad5e$export$d407e9ce7f74386b);
$parcel$export(module.exports, "getClosestAncestorWithViewRestrictions", () => $604ab07d7457ad5e$export$152ce6697c74bacb);

var $8fGsJ = parcelRequire("8fGsJ");

var $8Yqmp = parcelRequire("8Yqmp");
function $604ab07d7457ad5e$export$1864618d14e03dd7(data, publicLinkPageData, spaceKey, contentType, edition) {
    const currentUser = (0, $8Yqmp.getCurrentUserPrincipal)(data.user);
    if (!currentUser) return null;
    const contentData = $604ab07d7457ad5e$var$getContentData(data.content, currentUser);
    if (!contentData) return null;
    return {
        ...contentData,
        spaceKey: spaceKey,
        currentUser: currentUser,
        publicLinkPageData: publicLinkPageData,
        userCanEditRestrictions: $604ab07d7457ad5e$export$d407e9ce7f74386b(data, contentData.contentRestrictions.generalAccessLevel, contentType),
        edition: edition
    };
}
function $604ab07d7457ad5e$export$d407e9ce7f74386b(data, generalAccessLevel, contentType) {
    const contentNode = data?.content?.nodes?.[0];
    const operationsData = contentNode?.operations || [];
    const isSpaceAdmin = data?.space?.currentUser?.isAdmin || false;
    // Check if the current content type has a restrict_content operation
    const canRestrictContent = operationsData.some((operation)=>operation?.operation === 'restrict_content' && operation?.targetType === contentType);
    if (generalAccessLevel === 'open-can-edit') return canRestrictContent;
    const userHasEditRestrictions = operationsData.some((operation)=>operation?.operation === 'update' && operation?.targetType === contentType);
    return canRestrictContent && userHasEditRestrictions || isSpaceAdmin;
}
/**  Extracts all the QueriesState data that can be obtained from the `content` node */ function $604ab07d7457ad5e$var$getContentData(content, currentUser) {
    if (!content) return null;
    const { nodes: nodes } = content;
    if (!nodes) return null;
    const [node0] = nodes;
    if (!node0) return null;
    const { restrictions: restrictions, hasInheritedRestrictions: hasInheritedRestrictions, ancestors: ancestors } = node0;
    if (!restrictions) return null;
    const contentRestrictionsAndCounts = (0, $8fGsJ.getContentRestrictions)(restrictions, currentUser);
    if (!contentRestrictionsAndCounts) return null;
    const parentPageLink = hasInheritedRestrictions ? $604ab07d7457ad5e$export$152ce6697c74bacb(ancestors) : null;
    return {
        contentRestrictions: {
            generalAccessLevel: contentRestrictionsAndCounts.generalAccessLevel,
            principals: contentRestrictionsAndCounts.principals
        },
        numberOfAncestors: ancestors?.length || 0,
        groupCount: contentRestrictionsAndCounts.groupCount,
        currentUserHasAccess: contentRestrictionsAndCounts.currentUserHasAccess,
        hasInheritedRestrictions: hasInheritedRestrictions,
        parentPageLink: parentPageLink
    };
}
function $604ab07d7457ad5e$export$152ce6697c74bacb(ancestors) {
    const closestBoundingPage = {
        id: '',
        link: null
    };
    // Last ancestor is closest bounding
    if (ancestors) {
        for(let i = ancestors.length - 1; i >= 0; i--)if (ancestors[i]?.hasViewRestrictions) {
            closestBoundingPage.id = ancestors[i]?.id || '';
            closestBoundingPage.link = ancestors[i]?.links?.webui;
            break;
        }
    }
    return closestBoundingPage.link;
}

});
parcelRegister("8Yqmp", function(module, exports) {

$parcel$export(module.exports, "getCurrentUserPrincipal", () => $6a9739d895e9ee33$export$ebb637dbfb7941d3);
function $6a9739d895e9ee33$export$ebb637dbfb7941d3(user) {
    if (!user) return null;
    // Insist on a bare minimum of profile data
    const { id: id, displayName: displayName, photos: photos, emails: emails } = user;
    if (!id) return null;
    if (!displayName) return null;
    return {
        type: 'user',
        id: id,
        name: displayName,
        avatarUrl: $6a9739d895e9ee33$var$getPrimaryValue(photos),
        email: $6a9739d895e9ee33$var$getPrimaryValue(emails),
        knownErrors: undefined,
        sitePermissionType: 'INTERNAL'
    };
}
function $6a9739d895e9ee33$var$getPrimaryValue(maybeList) {
    let best = '';
    if (maybeList) for (const item of maybeList){
        if (!item) continue;
        const { value: value, isPrimary: isPrimary } = item;
        if (!value) continue;
        best = value;
        if (isPrimary) break;
    }
    return best;
}

});


parcelRegister("hfPJk", function(module, exports) {

$parcel$export(module.exports, "useUnifiedShareDialogEligible", () => $4c837cd68f9ce4c0$export$ec1a39480eeb12ae);

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $6mKj3 = parcelRequire("6mKj3");
const $4c837cd68f9ce4c0$export$ec1a39480eeb12ae = (skipExposure = false)=>{
    const { edition: edition, isLoggedIn: isLoggedIn, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isLicensed = [
        (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS,
        (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS
    ].includes(accessStatus);
    const isStandard = [
        (0, $euL71.ConfluenceEdition).STANDARD
    ].includes(edition);
    const isEligible = isLoggedIn && isLicensed && isStandard;
    return {
        isUSDExperimentEnabled: isEligible ? skipExposure ? (0, $6mKj3.expValEqualsNoExposure)('unified_share_dialog_usd_experiment', 'cohort', 'test') : (0, $6mKj3.expValEquals)('unified_share_dialog_usd_experiment', 'cohort', 'test') : false
    };
};

});

parcelRegister("aV3a0", function(module, exports) {

$parcel$export(module.exports, "useTitleContentPropertiesForEditor", () => $c042cea05c5afe3c$export$e3e4716593714d84);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $diswb = parcelRequire("diswb");

var $aTqya = parcelRequire("aTqya");

var $bT0se = parcelRequire("bT0se");

var $5ZqQS = parcelRequire("5ZqQS");

var $dIouf = parcelRequire("dIouf");

var $7Sm4c = parcelRequire("7Sm4c");

var $hF4tl = parcelRequire("hF4tl");

var $2eBB6 = parcelRequire("2eBB6");

var $gzIc1 = parcelRequire("gzIc1");

var $jVylI = parcelRequire("jVylI");
const $c042cea05c5afe3c$export$56ad806c83a5bd5e = (queryData)=>queryData?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.find((node)=>node?.key === 'page-title-property-draft');
// eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages
const $c042cea05c5afe3c$var$i18n = (0, $2nPZH.defineMessages)({
    errorFlagTitle: {
        id: "custom-sites-extensions.page-title.alignment.error.title",
        defaultMessage: "We couldn\u2019t update the title alignment"
    },
    errorFlagDescription: {
        id: "custom-sites-extensions.page-title.alignment.error.description",
        defaultMessage: "Try again, or refresh the page."
    }
});
const $c042cea05c5afe3c$export$e3e4716593714d84 = ({ contentId: contentId, propertyKey: propertyKey = 'page-title-property-draft', isDelete: isDelete = false, loadTitleContentProperties: loadTitleContentProperties = false, updateAlignmentState: updateAlignmentState, updateCoverPictureWidthState: updateCoverPictureWidthState, contentType: contentType, flags: flags, updateIsLoadingComplete: updateIsLoadingComplete })=>{
    const isInitialLoadComplete = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(false);
    const isTitleCenteredInitial = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(false);
    const handleError = (0, $gwFzn.useCallback)((error, suppressErrors)=>{
        const isUnauthOrNotFoundError = (0, $dIouf.isUnauthorizedError)(error) || (0, $dIouf.isNotFoundError)(error);
        if (!isUnauthOrNotFoundError) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $dIouf.Attribution).COMPANY_HUB
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (!suppressErrors) flags?.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $c042cea05c5afe3c$var$i18n.errorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $c042cea05c5afe3c$var$i18n.errorFlagDescription)
        });
    }, [
        flags
    ]);
    const getAlignmentFromContentProperty = (response)=>{
        const titlePropertyContent = $c042cea05c5afe3c$export$56ad806c83a5bd5e(response);
        if (titlePropertyContent?.value) try {
            return (0, $gzIc1.contentPropertyHelper)(titlePropertyContent)?.titleLayoutAlignment || (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        } catch (e) {
            handleError(e, false);
            return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        }
        else return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
    };
    const onCompleted = (response)=>{
        const coverPictureWidth = response.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
        updateAlignmentState?.(getAlignmentFromContentProperty(response));
        updateCoverPictureWidthState?.(coverPictureWidth);
    };
    const { data: data, networkStatus: networkStatus, refetch: refetchProperties } = (0, $diswb.useQuery)((0, $2eBB6.TitleContentPropertyQuery), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ]
        },
        fetchPolicy: Boolean(window.__SSR_RENDERED__) ? 'cache-first' : 'cache-and-network',
        // cache-and-network is required for: edit cover width, transition out of edit, transition back to edit for same page (for Live Docs and Classic pages)
        onError: (error)=>{
            handleError(error, true);
        },
        skip: !(loadTitleContentProperties || Boolean(window.__SSR_RENDERED__)),
        notifyOnNetworkStatusChange: true
    });
    const isTitleAlignmentLoading = networkStatus === (0, $aTqya.NetworkStatus).loading && !data;
    const refetchLoading = networkStatus === (0, $aTqya.NetworkStatus).refetch;
    const coverImageWidthCached = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth;
    isTitleCenteredInitial.current = (Boolean(window.__SSR_RENDERED__) || !isTitleAlignmentLoading) && getAlignmentFromContentProperty(data) === (0, $jVylI.TitleAlignmentType).CENTER;
    if (!isInitialLoadComplete.current && loadTitleContentProperties && data) {
        isInitialLoadComplete.current = true;
        onCompleted(data);
        updateIsLoadingComplete?.(true);
    }
    const [updateProperties, { loading: isUpdatingAlignment }] = (0, $diswb.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $hF4tl.TitleContentPropertyMutation));
    const onUpdatedPageTitleProperty = (0, $gwFzn.useCallback)((_eventName, _pubSubData)=>{
        try {
            const newContentState = JSON.parse(_pubSubData?.contentPropertyUpdateRequestBody?.value);
            updateAlignmentState?.(newContentState?.titleLayoutAlignment);
        } catch (error) {
            handleError(error, false);
        }
    }, [
        updateAlignmentState,
        handleError
    ]);
    (0, $bT0se.usePubSubEvent)({
        contentId: contentId,
        contentType: contentType || 'page',
        eventName: 'updated:pageTitleProperty',
        onEvent: onUpdatedPageTitleProperty
    });
    const updatePageTitleProperty = (0, $gwFzn.useCallback)(async (propertyValue)=>{
        try {
            const getVersionNumber = (data)=>data?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.[0]?.version?.number || 0;
            const versionData = await refetchProperties();
            const versionNumber = getVersionNumber(versionData.data);
            const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
            const optimisticResponse = {
                __typename: 'Mutation',
                experimentalUpdateContentProperty: {
                    __typename: 'experimentalUpdateContentProperty',
                    success: true,
                    id: contentId,
                    key: propertyKey,
                    value: propertyValue
                }
            };
            await updateProperties({
                variables: {
                    contentId: contentId,
                    propertyKey: propertyKey,
                    isDelete: isDelete,
                    propertyValue: propertyValue,
                    versionNumber: String(newVersionNumber)
                },
                optimisticResponse: optimisticResponse,
                update: (proxy)=>{
                    try {
                        const cacheData = proxy.readQuery({
                            query: (0, $2eBB6.TitleContentPropertyQuery),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft',
                                    'archived'
                                ]
                            }
                        });
                        cacheData.content.nodes[0].pageTitleDraft.nodes[0] = {
                            ...cacheData.content.nodes[0].pageTitleDraft.nodes[0],
                            id: contentId,
                            key: propertyKey,
                            value: JSON.stringify(propertyValue),
                            version: {
                                number: newVersionNumber,
                                __typename: 'Version'
                            }
                        };
                        proxy.writeQuery({
                            query: (0, $2eBB6.TitleContentPropertyQuery),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft',
                                    'archived'
                                ]
                            },
                            data: data
                        });
                    } catch (error) {
                        throw new Error(` failed to write to cache while updating ${propertyKey} content property after user updated page title${error.message}`);
                    }
                }
            });
        } catch (err) {
            handleError(err, false);
        }
    }, [
        propertyKey,
        contentId,
        isDelete,
        updateProperties,
        refetchProperties,
        data,
        handleError
    ]);
    return {
        isUpdatingAlignment: isUpdatingAlignment || refetchLoading,
        updatePageTitleProperty: updatePageTitleProperty,
        onCompleted: // exported for testing purposes
        onCompleted,
        isTitleAlignmentLoading: isTitleAlignmentLoading,
        isTitleCenteredInitial: isTitleCenteredInitial.current,
        coverImageWidthCached: coverImageWidthCached
    };
};

});
parcelRegister("hF4tl", function(module, exports) {

$parcel$export(module.exports, "TitleContentPropertyMutation", () => $4554de32334f15b6$export$128da188307c443c);

var $d2LG0 = parcelRequire("d2LG0");
const $4554de32334f15b6$export$128da188307c443c = (0, $d2LG0.default)`mutation TitleContentPropertyMutation($contentId:String!$propertyKey:String!$propertyValue:String$versionNumber:String$isDelete:Boolean)@experimental{experimentalUpdateContentProperty(contentId:$contentId propertyKey:$propertyKey propertyValue:$propertyValue versionNumber:$versionNumber isDelete:$isDelete){success id key value}}`;

});


parcelRegister("lOI2p", function(module, exports) {

$parcel$export(module.exports, "useInlineDialogCloseManager", () => $d8ad782c0a3406d7$export$8cca2d6324f11821);

var $gwFzn = parcelRequire("gwFzn");
const $d8ad782c0a3406d7$export$8cca2d6324f11821 = ({ onClose: onClose, popupRef: popupRef, triggerRef: triggerRef })=>{
    (0, $gwFzn.useEffect)(()=>{
        if (!popupRef) return;
        const keyDownEvent = ({ key: key })=>{
            if (key === 'Escape' || key === 'Esc') onClose();
        };
        const clickEvent = (event)=>{
            // Refresh button inside Forge app triggers earlier then clickEvent
            // Forge App starts update and popup does not have event.target anymore
            if (!document.body.contains(event.target)) return;
            // Do not close if interaction was performed on the current popup
            if (popupRef && popupRef.contains(event.target)) return;
            // Do not close if interaction was performed on the trigger container
            if (triggerRef && triggerRef.contains(event.target)) return;
            // Do not close if interaction was performed on the ModalDialog with an error
            if (event.target.closest('.atlaskit-portal-container [role=dialog]')) return;
            onClose();
        };
        window.addEventListener('click', clickEvent);
        window.addEventListener('keydown', keyDownEvent);
        return ()=>{
            window.removeEventListener('click', clickEvent);
            window.removeEventListener('keydown', keyDownEvent);
        };
    }, [
        popupRef,
        triggerRef,
        onClose
    ]);
};

});

parcelRegister("4vC63", function(module, exports) {

$parcel$export(module.exports, "ForgeKeyboardShortcutVisualizer", () => $c1fece3650e281b8$export$b804abdac3f5f117);
$parcel$export(module.exports, "ForgeKeyboardShortcut", () => $c1fece3650e281b8$export$4e51bfd8ba3e71ef);

var $gwFzn = parcelRequire("gwFzn");

var $3gadb = parcelRequire("3gadb");

var $ljm2R = parcelRequire("ljm2R");
const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $ljm2R.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $ljm2R.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $ljm2R.ShortcutType).Forge
    }));
    return null;
};

});

parcelRegister("f1f8Q", function(module, exports) {

$parcel$export(module.exports, "ContentChangeListener", () => $42e36a9cc64b173f$export$cb64fead8db45252);

var $gwFzn = parcelRequire("gwFzn");

var $2jjxD = parcelRequire("2jjxD");
const $42e36a9cc64b173f$export$cb64fead8db45252 = ({ onUpdate: onUpdate, popupRef: popupRef, children: children })=>{
    (0, $gwFzn.useEffect)(()=>{
        if (!popupRef) return;
        const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(onUpdate, 100);
        // Workaround to update popup position (by using scheduleUpdate function)
        // on any Forge App mutation
        const observer = new MutationObserver(()=>{
            updateWithDelay();
        });
        observer.observe(popupRef, {
            childList: true,
            subtree: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        popupRef,
        onUpdate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children);
};

});

parcelRegister("7QUD1", function(module, exports) {

$parcel$export(module.exports, "ByLineForgeApp", () => $02976f123c8f8e25$export$d2159b9f3f077903);
$parcel$export(module.exports, "ContentActionForgeApp", () => $02976f123c8f8e25$export$f900958ce7c4410f);
$parcel$export(module.exports, "ContextMenuForgeApp", () => $02976f123c8f8e25$export$79ed117743c6c2cf);
$parcel$export(module.exports, "GlobalPageForgeApp", () => $02976f123c8f8e25$export$83db8797814193a8);
$parcel$export(module.exports, "GlobalSettingsForgeApp", () => $02976f123c8f8e25$export$74528162c4c3828b);
$parcel$export(module.exports, "HomepageFeedForgeApp", () => $02976f123c8f8e25$export$c8291e2d6d6adbf2);
$parcel$export(module.exports, "SpaceSettingsForgeApp", () => $02976f123c8f8e25$export$e8858129e933f7e8);
$parcel$export(module.exports, "CustomContentForgeApp", () => $02976f123c8f8e25$export$578d0cbdb0ffa72e);
$parcel$export(module.exports, "BackgroundScriptForgeApp", () => $02976f123c8f8e25$export$40d4b5cfa6c18ea7);
$parcel$export(module.exports, "PageBannerForgeApp", () => $02976f123c8f8e25$export$c76787f94e0b1609);

var $jmjWc = parcelRequire("jmjWc");

const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("kmrDc"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("jsMCE"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("fHyq6"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("25dkF"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("5gRBE"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("16svW"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("2NypD"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("6z8C2"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("kPSYB"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("8LWT2"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("kTgSx"))).PageBannerForgeApp
});

});
parcelRegister("kmrDc", function(module, exports) {

let $ed2b4bbc2ecf2f62$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ed2b4bbc2ecf2f62$var$load("f0WOR"),
    $ed2b4bbc2ecf2f62$var$load("k7roz"),
    $ed2b4bbc2ecf2f62$var$load("is6uI"),
    $ed2b4bbc2ecf2f62$var$load("bKdog"),
    $ed2b4bbc2ecf2f62$var$load("8eNS3"),
    $ed2b4bbc2ecf2f62$var$load("50LrB"),
    $ed2b4bbc2ecf2f62$var$load("77pyi"),
    $ed2b4bbc2ecf2f62$var$load("4gZEH"),
    $ed2b4bbc2ecf2f62$var$load("gkmZg"),
    $ed2b4bbc2ecf2f62$var$load("jQFGH"),
    $ed2b4bbc2ecf2f62$var$load("fQ1rW"),
    $ed2b4bbc2ecf2f62$var$load("4tUsp"),
    $ed2b4bbc2ecf2f62$var$load("f96v0"),
    $ed2b4bbc2ecf2f62$var$load("5tHTv"),
    $ed2b4bbc2ecf2f62$var$load("26IOy"),
    $ed2b4bbc2ecf2f62$var$load("2nuqm"),
    $ed2b4bbc2ecf2f62$var$load("8MOue"),
    $ed2b4bbc2ecf2f62$var$load("i8Lm5"),
    $ed2b4bbc2ecf2f62$var$load("7X74w"),
    $ed2b4bbc2ecf2f62$var$load("gcyau"),
    $ed2b4bbc2ecf2f62$var$load("gavZG"),
    $ed2b4bbc2ecf2f62$var$load("1hjmQ"),
    $ed2b4bbc2ecf2f62$var$load("h4Nf7"),
    $ed2b4bbc2ecf2f62$var$load("4fCJZ"),
    $ed2b4bbc2ecf2f62$var$load("aqWBW"),
    $ed2b4bbc2ecf2f62$var$load("6StWh"),
    $ed2b4bbc2ecf2f62$var$load("g9CVe"),
    $ed2b4bbc2ecf2f62$var$load("U7y88"),
    $ed2b4bbc2ecf2f62$var$load("fEx3B"),
    $ed2b4bbc2ecf2f62$var$load("dJQEi"),
    $ed2b4bbc2ecf2f62$var$load("j4gWN"),
    $ed2b4bbc2ecf2f62$var$load("aZinD"),
    $ed2b4bbc2ecf2f62$var$load("6qah4"),
    $ed2b4bbc2ecf2f62$var$load("c6MKV"),
    $ed2b4bbc2ecf2f62$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("jsMCE", function(module, exports) {

let $e2b65942dfefeb85$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e2b65942dfefeb85$var$load("f0WOR"),
    $e2b65942dfefeb85$var$load("k7roz"),
    $e2b65942dfefeb85$var$load("is6uI"),
    $e2b65942dfefeb85$var$load("bKdog"),
    $e2b65942dfefeb85$var$load("8eNS3"),
    $e2b65942dfefeb85$var$load("50LrB"),
    $e2b65942dfefeb85$var$load("77pyi"),
    $e2b65942dfefeb85$var$load("4gZEH"),
    $e2b65942dfefeb85$var$load("gkmZg"),
    $e2b65942dfefeb85$var$load("jQFGH"),
    $e2b65942dfefeb85$var$load("fQ1rW"),
    $e2b65942dfefeb85$var$load("4tUsp"),
    $e2b65942dfefeb85$var$load("f96v0"),
    $e2b65942dfefeb85$var$load("5tHTv"),
    $e2b65942dfefeb85$var$load("26IOy"),
    $e2b65942dfefeb85$var$load("2nuqm"),
    $e2b65942dfefeb85$var$load("8MOue"),
    $e2b65942dfefeb85$var$load("i8Lm5"),
    $e2b65942dfefeb85$var$load("7X74w"),
    $e2b65942dfefeb85$var$load("gcyau"),
    $e2b65942dfefeb85$var$load("gavZG"),
    $e2b65942dfefeb85$var$load("1hjmQ"),
    $e2b65942dfefeb85$var$load("h4Nf7"),
    $e2b65942dfefeb85$var$load("4fCJZ"),
    $e2b65942dfefeb85$var$load("aqWBW"),
    $e2b65942dfefeb85$var$load("6StWh"),
    $e2b65942dfefeb85$var$load("g9CVe"),
    $e2b65942dfefeb85$var$load("U7y88"),
    $e2b65942dfefeb85$var$load("fEx3B"),
    $e2b65942dfefeb85$var$load("dJQEi"),
    $e2b65942dfefeb85$var$load("j4gWN"),
    $e2b65942dfefeb85$var$load("aZinD"),
    $e2b65942dfefeb85$var$load("6qah4"),
    $e2b65942dfefeb85$var$load("c6MKV"),
    $e2b65942dfefeb85$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("fHyq6", function(module, exports) {

let $b6e5924932381a65$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b6e5924932381a65$var$load("f0WOR"),
    $b6e5924932381a65$var$load("k7roz"),
    $b6e5924932381a65$var$load("is6uI"),
    $b6e5924932381a65$var$load("bKdog"),
    $b6e5924932381a65$var$load("8eNS3"),
    $b6e5924932381a65$var$load("50LrB"),
    $b6e5924932381a65$var$load("77pyi"),
    $b6e5924932381a65$var$load("4gZEH"),
    $b6e5924932381a65$var$load("gkmZg"),
    $b6e5924932381a65$var$load("jQFGH"),
    $b6e5924932381a65$var$load("fQ1rW"),
    $b6e5924932381a65$var$load("4tUsp"),
    $b6e5924932381a65$var$load("f96v0"),
    $b6e5924932381a65$var$load("5tHTv"),
    $b6e5924932381a65$var$load("26IOy"),
    $b6e5924932381a65$var$load("2nuqm"),
    $b6e5924932381a65$var$load("8MOue"),
    $b6e5924932381a65$var$load("i8Lm5"),
    $b6e5924932381a65$var$load("7X74w"),
    $b6e5924932381a65$var$load("gcyau"),
    $b6e5924932381a65$var$load("gavZG"),
    $b6e5924932381a65$var$load("1hjmQ"),
    $b6e5924932381a65$var$load("h4Nf7"),
    $b6e5924932381a65$var$load("4fCJZ"),
    $b6e5924932381a65$var$load("aqWBW"),
    $b6e5924932381a65$var$load("6StWh"),
    $b6e5924932381a65$var$load("g9CVe"),
    $b6e5924932381a65$var$load("U7y88"),
    $b6e5924932381a65$var$load("fEx3B"),
    $b6e5924932381a65$var$load("dJQEi"),
    $b6e5924932381a65$var$load("j4gWN"),
    $b6e5924932381a65$var$load("aZinD"),
    $b6e5924932381a65$var$load("6qah4"),
    $b6e5924932381a65$var$load("c6MKV"),
    $b6e5924932381a65$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("25dkF", function(module, exports) {

let $184663f043f29a90$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $184663f043f29a90$var$load("k7roz"),
    $184663f043f29a90$var$load("is6uI"),
    $184663f043f29a90$var$load("4gZEH"),
    $184663f043f29a90$var$load("gkmZg"),
    $184663f043f29a90$var$load("kQvbt"),
    $184663f043f29a90$var$load("jQFGH"),
    $184663f043f29a90$var$load("fQ1rW"),
    $184663f043f29a90$var$load("4tUsp"),
    $184663f043f29a90$var$load("26IOy"),
    $184663f043f29a90$var$load("2nuqm"),
    $184663f043f29a90$var$load("8MOue"),
    $184663f043f29a90$var$load("i8Lm5"),
    $184663f043f29a90$var$load("7X74w"),
    $184663f043f29a90$var$load("gcyau"),
    $184663f043f29a90$var$load("gavZG"),
    $184663f043f29a90$var$load("1hjmQ"),
    $184663f043f29a90$var$load("h4Nf7"),
    $184663f043f29a90$var$load("4fCJZ"),
    $184663f043f29a90$var$load("9FBaW"),
    $184663f043f29a90$var$load("aqWBW"),
    $184663f043f29a90$var$load("6StWh"),
    $184663f043f29a90$var$load("g9CVe"),
    $184663f043f29a90$var$load("U7y88"),
    $184663f043f29a90$var$load("fEx3B"),
    $184663f043f29a90$var$load("dJQEi"),
    $184663f043f29a90$var$load("6qah4"),
    $184663f043f29a90$var$load("j4gWN"),
    $184663f043f29a90$var$load("87F9B"),
    $184663f043f29a90$var$load("aZinD"),
    $184663f043f29a90$var$load("c6MKV"),
    $184663f043f29a90$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("5gRBE", function(module, exports) {

let $3d680776abdd4bef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3d680776abdd4bef$var$load("k7roz"),
    $3d680776abdd4bef$var$load("is6uI"),
    $3d680776abdd4bef$var$load("4gZEH"),
    $3d680776abdd4bef$var$load("gkmZg"),
    $3d680776abdd4bef$var$load("kQvbt"),
    $3d680776abdd4bef$var$load("jQFGH"),
    $3d680776abdd4bef$var$load("fQ1rW"),
    $3d680776abdd4bef$var$load("4tUsp"),
    $3d680776abdd4bef$var$load("26IOy"),
    $3d680776abdd4bef$var$load("2nuqm"),
    $3d680776abdd4bef$var$load("8MOue"),
    $3d680776abdd4bef$var$load("i8Lm5"),
    $3d680776abdd4bef$var$load("7X74w"),
    $3d680776abdd4bef$var$load("gcyau"),
    $3d680776abdd4bef$var$load("gavZG"),
    $3d680776abdd4bef$var$load("1hjmQ"),
    $3d680776abdd4bef$var$load("h4Nf7"),
    $3d680776abdd4bef$var$load("4fCJZ"),
    $3d680776abdd4bef$var$load("9FBaW"),
    $3d680776abdd4bef$var$load("aqWBW"),
    $3d680776abdd4bef$var$load("6StWh"),
    $3d680776abdd4bef$var$load("g9CVe"),
    $3d680776abdd4bef$var$load("U7y88"),
    $3d680776abdd4bef$var$load("fEx3B"),
    $3d680776abdd4bef$var$load("dJQEi"),
    $3d680776abdd4bef$var$load("6qah4"),
    $3d680776abdd4bef$var$load("j4gWN"),
    $3d680776abdd4bef$var$load("87F9B"),
    $3d680776abdd4bef$var$load("aZinD"),
    $3d680776abdd4bef$var$load("c6MKV"),
    $3d680776abdd4bef$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("16svW", function(module, exports) {

let $0cdc784e9d9ab7cd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0cdc784e9d9ab7cd$var$load("k7roz"),
    $0cdc784e9d9ab7cd$var$load("is6uI"),
    $0cdc784e9d9ab7cd$var$load("lnKog"),
    $0cdc784e9d9ab7cd$var$load("4gZEH"),
    $0cdc784e9d9ab7cd$var$load("gkmZg"),
    $0cdc784e9d9ab7cd$var$load("kQvbt"),
    $0cdc784e9d9ab7cd$var$load("jQFGH"),
    $0cdc784e9d9ab7cd$var$load("fQ1rW"),
    $0cdc784e9d9ab7cd$var$load("4tUsp"),
    $0cdc784e9d9ab7cd$var$load("26IOy"),
    $0cdc784e9d9ab7cd$var$load("2nuqm"),
    $0cdc784e9d9ab7cd$var$load("8MOue"),
    $0cdc784e9d9ab7cd$var$load("i8Lm5"),
    $0cdc784e9d9ab7cd$var$load("7X74w"),
    $0cdc784e9d9ab7cd$var$load("gcyau"),
    $0cdc784e9d9ab7cd$var$load("gavZG"),
    $0cdc784e9d9ab7cd$var$load("1hjmQ"),
    $0cdc784e9d9ab7cd$var$load("h4Nf7"),
    $0cdc784e9d9ab7cd$var$load("4fCJZ"),
    $0cdc784e9d9ab7cd$var$load("9FBaW"),
    $0cdc784e9d9ab7cd$var$load("aqWBW"),
    $0cdc784e9d9ab7cd$var$load("6StWh"),
    $0cdc784e9d9ab7cd$var$load("g9CVe"),
    $0cdc784e9d9ab7cd$var$load("U7y88"),
    $0cdc784e9d9ab7cd$var$load("fEx3B"),
    $0cdc784e9d9ab7cd$var$load("dJQEi"),
    $0cdc784e9d9ab7cd$var$load("6qah4"),
    $0cdc784e9d9ab7cd$var$load("j4gWN"),
    $0cdc784e9d9ab7cd$var$load("87F9B"),
    $0cdc784e9d9ab7cd$var$load("aZinD"),
    $0cdc784e9d9ab7cd$var$load("c6MKV"),
    $0cdc784e9d9ab7cd$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("2NypD", function(module, exports) {

let $209ad9fc35231a6e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $209ad9fc35231a6e$var$load("k7roz"),
    $209ad9fc35231a6e$var$load("is6uI"),
    $209ad9fc35231a6e$var$load("4gZEH"),
    $209ad9fc35231a6e$var$load("gkmZg"),
    $209ad9fc35231a6e$var$load("kQvbt"),
    $209ad9fc35231a6e$var$load("jQFGH"),
    $209ad9fc35231a6e$var$load("fQ1rW"),
    $209ad9fc35231a6e$var$load("4tUsp"),
    $209ad9fc35231a6e$var$load("f96v0"),
    $209ad9fc35231a6e$var$load("ev7SX"),
    $209ad9fc35231a6e$var$load("5tHTv"),
    $209ad9fc35231a6e$var$load("26IOy"),
    $209ad9fc35231a6e$var$load("2nuqm"),
    $209ad9fc35231a6e$var$load("8MOue"),
    $209ad9fc35231a6e$var$load("i8Lm5"),
    $209ad9fc35231a6e$var$load("7X74w"),
    $209ad9fc35231a6e$var$load("gcyau"),
    $209ad9fc35231a6e$var$load("gavZG"),
    $209ad9fc35231a6e$var$load("1hjmQ"),
    $209ad9fc35231a6e$var$load("h4Nf7"),
    $209ad9fc35231a6e$var$load("4fCJZ"),
    $209ad9fc35231a6e$var$load("dTsOE"),
    $209ad9fc35231a6e$var$load("9FBaW"),
    $209ad9fc35231a6e$var$load("aqWBW"),
    $209ad9fc35231a6e$var$load("6StWh"),
    $209ad9fc35231a6e$var$load("g9CVe"),
    $209ad9fc35231a6e$var$load("U7y88"),
    $209ad9fc35231a6e$var$load("fEx3B"),
    $209ad9fc35231a6e$var$load("dJQEi"),
    $209ad9fc35231a6e$var$load("6qah4"),
    $209ad9fc35231a6e$var$load("j4gWN"),
    $209ad9fc35231a6e$var$load("87F9B"),
    $209ad9fc35231a6e$var$load("aZinD"),
    $209ad9fc35231a6e$var$load("c6MKV"),
    $209ad9fc35231a6e$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("6z8C2", function(module, exports) {

let $4c7cb13fd3782694$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $4c7cb13fd3782694$var$load("k7roz"),
    $4c7cb13fd3782694$var$load("is6uI"),
    $4c7cb13fd3782694$var$load("4gZEH"),
    $4c7cb13fd3782694$var$load("gkmZg"),
    $4c7cb13fd3782694$var$load("kQvbt"),
    $4c7cb13fd3782694$var$load("jQFGH"),
    $4c7cb13fd3782694$var$load("fQ1rW"),
    $4c7cb13fd3782694$var$load("4tUsp"),
    $4c7cb13fd3782694$var$load("f96v0"),
    $4c7cb13fd3782694$var$load("ev7SX"),
    $4c7cb13fd3782694$var$load("5tHTv"),
    $4c7cb13fd3782694$var$load("26IOy"),
    $4c7cb13fd3782694$var$load("2nuqm"),
    $4c7cb13fd3782694$var$load("8MOue"),
    $4c7cb13fd3782694$var$load("i8Lm5"),
    $4c7cb13fd3782694$var$load("7X74w"),
    $4c7cb13fd3782694$var$load("gcyau"),
    $4c7cb13fd3782694$var$load("gavZG"),
    $4c7cb13fd3782694$var$load("1hjmQ"),
    $4c7cb13fd3782694$var$load("h4Nf7"),
    $4c7cb13fd3782694$var$load("4fCJZ"),
    $4c7cb13fd3782694$var$load("dTsOE"),
    $4c7cb13fd3782694$var$load("aqWBW"),
    $4c7cb13fd3782694$var$load("6StWh"),
    $4c7cb13fd3782694$var$load("g9CVe"),
    $4c7cb13fd3782694$var$load("U7y88"),
    $4c7cb13fd3782694$var$load("fEx3B"),
    $4c7cb13fd3782694$var$load("dJQEi"),
    $4c7cb13fd3782694$var$load("6qah4"),
    $4c7cb13fd3782694$var$load("j4gWN"),
    $4c7cb13fd3782694$var$load("87F9B"),
    $4c7cb13fd3782694$var$load("aZinD"),
    $4c7cb13fd3782694$var$load("c6MKV"),
    $4c7cb13fd3782694$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("kPSYB", function(module, exports) {

let $f2b33744b032e45d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f2b33744b032e45d$var$load("k7roz"),
    $f2b33744b032e45d$var$load("is6uI"),
    $f2b33744b032e45d$var$load("4gZEH"),
    $f2b33744b032e45d$var$load("gkmZg"),
    $f2b33744b032e45d$var$load("kQvbt"),
    $f2b33744b032e45d$var$load("jQFGH"),
    $f2b33744b032e45d$var$load("fQ1rW"),
    $f2b33744b032e45d$var$load("4tUsp"),
    $f2b33744b032e45d$var$load("26IOy"),
    $f2b33744b032e45d$var$load("2nuqm"),
    $f2b33744b032e45d$var$load("8MOue"),
    $f2b33744b032e45d$var$load("i8Lm5"),
    $f2b33744b032e45d$var$load("7X74w"),
    $f2b33744b032e45d$var$load("gcyau"),
    $f2b33744b032e45d$var$load("gavZG"),
    $f2b33744b032e45d$var$load("1hjmQ"),
    $f2b33744b032e45d$var$load("h4Nf7"),
    $f2b33744b032e45d$var$load("4fCJZ"),
    $f2b33744b032e45d$var$load("9FBaW"),
    $f2b33744b032e45d$var$load("aqWBW"),
    $f2b33744b032e45d$var$load("6StWh"),
    $f2b33744b032e45d$var$load("g9CVe"),
    $f2b33744b032e45d$var$load("U7y88"),
    $f2b33744b032e45d$var$load("fEx3B"),
    $f2b33744b032e45d$var$load("dJQEi"),
    $f2b33744b032e45d$var$load("6qah4"),
    $f2b33744b032e45d$var$load("j4gWN"),
    $f2b33744b032e45d$var$load("87F9B"),
    $f2b33744b032e45d$var$load("aZinD"),
    $f2b33744b032e45d$var$load("c6MKV"),
    $f2b33744b032e45d$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("8LWT2", function(module, exports) {

let $66306432695390be$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $66306432695390be$var$load("k7roz"),
    $66306432695390be$var$load("is6uI"),
    $66306432695390be$var$load("lnKog"),
    $66306432695390be$var$load("4gZEH"),
    $66306432695390be$var$load("gkmZg"),
    $66306432695390be$var$load("kQvbt"),
    $66306432695390be$var$load("jQFGH"),
    $66306432695390be$var$load("fQ1rW"),
    $66306432695390be$var$load("4tUsp"),
    $66306432695390be$var$load("26IOy"),
    $66306432695390be$var$load("2nuqm"),
    $66306432695390be$var$load("8MOue"),
    $66306432695390be$var$load("i8Lm5"),
    $66306432695390be$var$load("7X74w"),
    $66306432695390be$var$load("gcyau"),
    $66306432695390be$var$load("gavZG"),
    $66306432695390be$var$load("1hjmQ"),
    $66306432695390be$var$load("h4Nf7"),
    $66306432695390be$var$load("4fCJZ"),
    $66306432695390be$var$load("9FBaW"),
    $66306432695390be$var$load("aqWBW"),
    $66306432695390be$var$load("6StWh"),
    $66306432695390be$var$load("g9CVe"),
    $66306432695390be$var$load("U7y88"),
    $66306432695390be$var$load("fEx3B"),
    $66306432695390be$var$load("dJQEi"),
    $66306432695390be$var$load("6qah4"),
    $66306432695390be$var$load("j4gWN"),
    $66306432695390be$var$load("87F9B"),
    $66306432695390be$var$load("aZinD"),
    $66306432695390be$var$load("c6MKV"),
    $66306432695390be$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("kTgSx", function(module, exports) {

let $f35609756c8b58bc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f35609756c8b58bc$var$load("k7roz"),
    $f35609756c8b58bc$var$load("is6uI"),
    $f35609756c8b58bc$var$load("lnKog"),
    $f35609756c8b58bc$var$load("4gZEH"),
    $f35609756c8b58bc$var$load("gkmZg"),
    $f35609756c8b58bc$var$load("kQvbt"),
    $f35609756c8b58bc$var$load("jQFGH"),
    $f35609756c8b58bc$var$load("fQ1rW"),
    $f35609756c8b58bc$var$load("4tUsp"),
    $f35609756c8b58bc$var$load("26IOy"),
    $f35609756c8b58bc$var$load("2nuqm"),
    $f35609756c8b58bc$var$load("8MOue"),
    $f35609756c8b58bc$var$load("i8Lm5"),
    $f35609756c8b58bc$var$load("7X74w"),
    $f35609756c8b58bc$var$load("gcyau"),
    $f35609756c8b58bc$var$load("gavZG"),
    $f35609756c8b58bc$var$load("1hjmQ"),
    $f35609756c8b58bc$var$load("h4Nf7"),
    $f35609756c8b58bc$var$load("4fCJZ"),
    $f35609756c8b58bc$var$load("9FBaW"),
    $f35609756c8b58bc$var$load("aqWBW"),
    $f35609756c8b58bc$var$load("6StWh"),
    $f35609756c8b58bc$var$load("g9CVe"),
    $f35609756c8b58bc$var$load("U7y88"),
    $f35609756c8b58bc$var$load("fEx3B"),
    $f35609756c8b58bc$var$load("dJQEi"),
    $f35609756c8b58bc$var$load("6qah4"),
    $f35609756c8b58bc$var$load("j4gWN"),
    $f35609756c8b58bc$var$load("87F9B"),
    $f35609756c8b58bc$var$load("aZinD"),
    $f35609756c8b58bc$var$load("c6MKV"),
    $f35609756c8b58bc$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});


parcelRegister("grspz", function(module, exports) {

$parcel$export(module.exports, "getLocalId", () => $cdcead6f01277136$export$957229695d10ea4a);
const $cdcead6f01277136$export$957229695d10ea4a = (extensionId)=>{
    return extensionId.replace(/[^a-zA-Z0-9-]/g, '-');
};

});

parcelRegister("8a9Dm", function(module, exports) {

$parcel$export(module.exports, "getAppId", () => $2cc1b73219e08564$export$fb2283f4a44fb53);
$parcel$export(module.exports, "getModuleKey", () => $2cc1b73219e08564$export$b17b21a48c0a3273);
$parcel$export(module.exports, "getCustomContentType", () => $2cc1b73219e08564$export$9eb690901638fb96);
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};

});

parcelRegister("hIaUw", function(module, exports) {

$parcel$export(module.exports, "getContentType", () => $5ff3d548ffdc5eda$export$1ef77878e4e0b972);
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};

});

parcelRegister("80koo", function(module, exports) {

$parcel$export(module.exports, "RequireLegacyWRM", () => $c65634971abef8c1$export$c2019f6d43c6c1ce);

var $gwFzn = parcelRequire("gwFzn");

var $cpjd2 = parcelRequire("cpjd2");
const $c65634971abef8c1$export$c2019f6d43c6c1ce = ({ wrm: wrm, children: children })=>{
    const [wrmLoadingState, setWrmLoadingState] = (0, $gwFzn.useState)({
        loaded: false,
        modules: []
    });
    (0, $gwFzn.useEffect)(()=>{
        (0, $cpjd2.requireLegacyWRM)(wrm, (modules)=>{
            setWrmLoadingState({
                loaded: true,
                modules: modules
            });
        }, ()=>{});
    }, [
        wrm
    ]);
    return wrmLoadingState.loaded && children ? children(wrmLoadingState.modules) : null;
};

});

parcelRegister("7XPIt", function(module, exports) {

$parcel$export(module.exports, "ATTACHMENTS_ANALYTICS_FROM_ACTIONS_MENU", () => $5cc628dffabd5f14$export$6f695b80f23f4114);
$parcel$export(module.exports, "ViewAttachmentsButton", () => $5cc628dffabd5f14$export$5c9f1ebb6c75cefb);
/* ViewAttachmentsButton.js generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $fppBw = parcelRequire("fppBw");

var $2nPZH = parcelRequire("2nPZH");
var $js7oX = parcelRequire("js7oX");

var $inPa6 = parcelRequire("inPa6");

var $4KS7f = parcelRequire("4KS7f");

var $9lz2c = parcelRequire("9lz2c");

var $2UWuP = parcelRequire("2UWuP");

var $jlIaF = parcelRequire("jlIaF");

var $ep3mz = parcelRequire("ep3mz");

var $dIouf = parcelRequire("dIouf");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5cc628dffabd5f14$var$ViewAttachmentsButtonContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1gflidpf _yhjmidpf _1gqnidpf _11lvidpf _1hbsidpf _1u71idpf _y2qtidpf _fl8bidpf _4rtxtlke _jq8g1ul9 _14hp1ul9 _43ds1gjq _oxk41gjq",
            __cmplp.className
        ])
    });
});
const $5cc628dffabd5f14$var$i18n = (0, $2nPZH.defineMessages)({
    attachments: {
        id: "attachments.view-attachments-button",
        defaultMessage: "View attachments"
    }
});
const $5cc628dffabd5f14$var$ATTACHMENTS_ANALYTICS_FROM_VIEW = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        actionSubject: 'ViewAttachmentsButton',
        source: 'attachments',
        attributes: {
            triggeredFrom: 'fromView'
        }
    }
};
const $5cc628dffabd5f14$export$6f695b80f23f4114 = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        actionSubject: 'ViewAttachmentsButton',
        source: 'attachments',
        attributes: {
            triggeredFrom: 'actionsMenu'
        }
    }
};
const $5cc628dffabd5f14$export$774c527e91be8e54 = ({ intl: intl })=>{
    const label = intl.formatMessage($5cc628dffabd5f14$var$i18n.attachments);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'feature',
            action: 'exposed',
            source: 'ViewAttachmentsButton',
            attributes: {
                isPageSSRd: window.__SSR_RENDERED__
            }
        }
    }).fire();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5cc628dffabd5f14$var$ViewAttachmentsButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KS7f.default), {
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
        analyticsData: $5cc628dffabd5f14$var$ATTACHMENTS_ANALYTICS_FROM_VIEW
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/viewpageattachments.action?pageId=${contentId}&metadataLink=true`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9lz2c))), {
        spacing: "spacious",
        label: label
    }))))));
};
$5cc628dffabd5f14$export$774c527e91be8e54.propTypes = {
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object
};
const $5cc628dffabd5f14$export$5c9f1ebb6c75cefb = (0, $js7oX.default)($5cc628dffabd5f14$export$774c527e91be8e54);

});
parcelRegister("2UWuP", function(module, exports) {

$parcel$export(module.exports, "WebItemAnalyticsWrapper", () => $1c62d6fee936c450$export$907c57431ebf932);

var $gwFzn = parcelRequire("gwFzn");

var $Asv1P = parcelRequire("Asv1P");
const $1c62d6fee936c450$var$noop = ()=>{};
function $1c62d6fee936c450$export$907c57431ebf932({ children: children, analyticsData: analyticsData, innerRef: innerRef, wrapChildren: wrapChildren = false }) {
    const handler = children?.props?.onClick || $1c62d6fee936c450$var$noop;
    const handleClick = (0, $Asv1P.useCallbackWithAnalytics)(handler, analyticsData);
    if (wrapChildren) return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        ref: innerRef,
        onMouseDown: handleClick
    }, children));
    return /*#__PURE__*/ (0, $gwFzn.cloneElement)(children, {
        onClick: handleClick,
        ref: innerRef
    });
}

});


parcelRegister("hFGQl", function(module, exports) {

$parcel$export(module.exports, "CONTENT_METADATA_JIRA_ID", () => $d3e8bd0515c02c91$export$8b02acc4219d8357);
$parcel$export(module.exports, "CONTENT_METADATA_ATTACHMENTS_ID", () => $d3e8bd0515c02c91$export$a93781d2f10a1a54);
$parcel$export(module.exports, "CONTENT_METADATA_PAGE_RESTRICTIONS_ID", () => $d3e8bd0515c02c91$export$126027a563ee39b2);
$parcel$export(module.exports, "DRAFT_STATUS_LOZENGE_ID", () => $d3e8bd0515c02c91$export$e5b04880f6b7bed);
$parcel$export(module.exports, "SCHEDULED_STATUS_LOZENGE_ID", () => $d3e8bd0515c02c91$export$b6c67256b8045624);
$parcel$export(module.exports, "EDIT_PAGE_METADATA_RESTRICTIONS_ID", () => $d3e8bd0515c02c91$export$1b048ac0db68f7ab);
$parcel$export(module.exports, "INVITE_TO_EDIT_ID", () => $d3e8bd0515c02c91$export$607df6eced5a588c);
$parcel$export(module.exports, "ANALYTICS_ADDON_BYLINE_ID", () => $d3e8bd0515c02c91$export$c8362b8678d6b894);
$parcel$export(module.exports, "ANALYTICS_ADDON_ACTIONS_MENU_ID", () => $d3e8bd0515c02c91$export$de7935ab18e02484);
$parcel$export(module.exports, "ANALYTICS_MODERATE_ADDON_ACTIONS_MENU_ID", () => $d3e8bd0515c02c91$export$a643e9449b465583);
const $d3e8bd0515c02c91$export$8b02acc4219d8357 = 'content-metadata-jira';
const $d3e8bd0515c02c91$export$a93781d2f10a1a54 = 'content-metadata-attachments';
const $d3e8bd0515c02c91$export$126027a563ee39b2 = 'content-metadata-page-restrictions';
const $d3e8bd0515c02c91$export$e5b04880f6b7bed = 'draft-status-lozenge';
const $d3e8bd0515c02c91$export$b6c67256b8045624 = 'status-lozenge-scheduled';
const $d3e8bd0515c02c91$export$1b048ac0db68f7ab = 'rte-button-restrictions';
const $d3e8bd0515c02c91$export$607df6eced5a588c = 'inviteToEdit';
const $d3e8bd0515c02c91$export$c8362b8678d6b894 = 'com.addonengine.analytics__analytics-content-byline-item';
const $d3e8bd0515c02c91$export$de7935ab18e02484 = 'com.addonengine.analytics__analytics-content-menu-item';
const $d3e8bd0515c02c91$export$a643e9449b465583 = 'com.addonengine.analytics.moderate__analytics-content-menu-item';

});

parcelRegister("lTH0u", function(module, exports) {

$parcel$export(module.exports, "ShareAndRestrictButton", () => $56d6569a62eec599$export$5894b1d1838f517c);
$parcel$export(module.exports, "getClosestAncestorWithViewRestrictions", () => (parcelRequire("gKilh")).getClosestAncestorWithViewRestrictions);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $7d2Nc = parcelRequire("7d2Nc");

var $9wGTI = parcelRequire("9wGTI");

var $ln0hx = parcelRequire("ln0hx");
var $irVI7 = parcelRequire("irVI7");

var $6R9D7 = parcelRequire("6R9D7");

var $gw4Bt = parcelRequire("gw4Bt");

var $gKilh = parcelRequire("gKilh");

const $56d6569a62eec599$var$ShareAndRestrictButtonSSRLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "uwAKZ",
    name: "ShareAndRestrictButtonSSRLoader",
    loader: async ()=>(await (parcelRequire("fzPvI"))).ShareRestrictAndCopyCoordinator
});

const $56d6569a62eec599$var$ShareAndRestrictButtonLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "_AU2w",
    name: "ShareAndRestrictButtonLoader",
    loader: async ()=>(await (parcelRequire("fzPvI"))).ShareRestrictAndCopyCoordinator,
    loading: (0, $6R9D7.ShareRestrictAndCopyButtonPlaceholder)
});
const $56d6569a62eec599$export$5894b1d1838f517c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD),
        isCustomStart: true,
        key: props.contentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE)
    }), !(0, $9wGTI.fg)('confluence_frontend_object_header') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($56d6569a62eec599$var$ShareAndRestrictButtonLoader, props) : (0, $9wGTI.fg)('confluence_frontend_usd_ssr') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($56d6569a62eec599$var$ShareAndRestrictButtonSSRLoader, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($56d6569a62eec599$var$ShareAndRestrictButtonLoader, props));

});
parcelRegister("6R9D7", function(module, exports) {

$parcel$export(module.exports, "ShareRestrictAndCopyButtonPlaceholder", () => $0d12a77155e451c7$export$4d89be89896b480);

var $gwFzn = parcelRequire("gwFzn");

var $1qfLF = parcelRequire("1qfLF");
var $9gE7g = parcelRequire("9gE7g");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $luv00 = parcelRequire("luv00");

var $jJAQO = parcelRequire("jJAQO");
const $0d12a77155e451c7$var$iconSkeletonStyle = (0, $ecnYn.xcss)({
    width: '16px',
    height: '16px',
    borderRadius: '2px',
    background: "var(--ds-background-accent-gray-subtlest-hovered, #DCDFE4)"
});
const $0d12a77155e451c7$var$SkeletonGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        testId: "icon-skeleton",
        xcss: $0d12a77155e451c7$var$iconSkeletonStyle
    });
const $0d12a77155e451c7$export$4d89be89896b480 = ()=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", ssrPlaceholderIdProp, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9gE7g.SplitButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jJAQO.ShareAndRestrictButtonPlaceholder), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        testId: "copy-link-button-placeholder",
        icon: $0d12a77155e451c7$var$SkeletonGlyph,
        label: "",
        isDisabled: true
    })));
};

});
parcelRegister("jJAQO", function(module, exports) {

$parcel$export(module.exports, "ShareAndRestrictButtonPlaceholder", () => $655fcee40b727ec5$export$b125768944fa8b3);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $ccHMk = parcelRequire("ccHMk");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $a5Qbj = parcelRequire("a5Qbj");
const $655fcee40b727ec5$var$iconSkeletonStyle = (0, $ecnYn.xcss)({
    width: '16px',
    height: '16px',
    borderRadius: '2px',
    marginLeft: 'space.050',
    marginRight: 'space.025',
    background: "var(--ds-background-accent-gray-subtlest-hovered, #DCDFE4)"
});
const $655fcee40b727ec5$var$SkeletonGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        testId: "icon-skeleton",
        xcss: $655fcee40b727ec5$var$iconSkeletonStyle
    });
const $655fcee40b727ec5$export$b125768944fa8b3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: "default",
        iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($655fcee40b727ec5$var$SkeletonGlyph, null),
        onClick: ()=>{},
        isDisabled: true,
        testId: "share-and-restrict-button-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $a5Qbj.i18n).share));

});
parcelRegister("a5Qbj", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $25f12149840db431$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "ControlledShareButton", () => $25f12149840db431$export$f939f151d984bfc);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $ccHMk = parcelRequire("ccHMk");

var $iEKnc = parcelRequire("iEKnc");

var $3gadb = parcelRequire("3gadb");

var $9Q2dU = parcelRequire("9Q2dU");

var $h1ewt = parcelRequire("h1ewt");

var $s1iYf = parcelRequire("s1iYf");
const $25f12149840db431$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    share: {
        id: "share-and-restrict-dialog.controlled-share-button.share",
        defaultMessage: "Share"
    }
});
const $25f12149840db431$var$ICON_PROP_TO_ICON_COMPONENT = {
    open: (0, (/*@__PURE__*/$parcel$interopDefault($h1ewt))),
    restricted: (0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))),
    public: (0, $s1iYf.WorldGreenDotGlyph),
    error: (0, (/*@__PURE__*/$parcel$interopDefault($iEKnc)))
};
const $25f12149840db431$var$makeIconProps = (icon, isDisabled)=>{
    if (isDisabled) return {
        color: "var(--ds-icon-disabled, #091E424F)"
    };
    switch(icon){
        case 'error':
            return {
                color: "var(--ds-icon-danger, #C9372C)"
            };
        case 'restricted':
            return {
                color: "var(--ds-icon-danger, #C9372C)"
            };
        default:
            return {
                color: "var(--ds-icon-subtle, #626F86)"
            };
    }
};
const $25f12149840db431$export$f939f151d984bfc = ({ icon: icon, onClick: onClick, tooltipMessage: tooltipMessage, isDisabled: isDisabled, children: children, focusRef: focusRef })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const Icon = $25f12149840db431$var$ICON_PROP_TO_ICON_COMPONENT[icon];
    const iconProps = {
        label: '',
        ...$25f12149840db431$var$makeIconProps(icon, isDisabled)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: formatMessage(tooltipMessage),
        position: "bottom",
        canAppear: ()=>!children,
        hideTooltipOnMouseDown: true,
        ignoreTooltipPointerEvents: true,
        delay: 100
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        iconBefore: (parentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Icon, {
                ...parentProps,
                ...iconProps
            }),
        onClick: onClick,
        "aria-label": `${formatMessage($25f12149840db431$export$a7357cdd1f0b0168.share)}, ${formatMessage(tooltipMessage)}`,
        isDisabled: isDisabled,
        ref: focusRef
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $25f12149840db431$export$a7357cdd1f0b0168.share)));
};

});



parcelRegister("gw4Bt", function(module, exports) {

$parcel$export(module.exports, "SHARE_BUTTON_PAGE_SEGMENT_LOAD", () => $08e48bbb9421afc0$export$8fdec53caa79133c);

var $lSOAM = parcelRequire("lSOAM");
var $jX1qB = parcelRequire("jX1qB");
const $08e48bbb9421afc0$export$8fdec53caa79133c = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
});

});

parcelRegister("fzPvI", function(module, exports) {

let $b57214d44d0fec84$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b57214d44d0fec84$var$load("3kHns"),
    $b57214d44d0fec84$var$load("3JzPO"),
    $b57214d44d0fec84$var$load("h4Nf7"),
    $b57214d44d0fec84$var$load("4fCJZ"),
    $b57214d44d0fec84$var$load("dTsOE"),
    $b57214d44d0fec84$var$load("6zfzy"),
    $b57214d44d0fec84$var$load("6StWh"),
    $b57214d44d0fec84$var$load("TpLgp"),
    $b57214d44d0fec84$var$load("1V0Ha"),
    $b57214d44d0fec84$var$load("gkmZg"),
    $b57214d44d0fec84$var$load("a4Sf9"),
    $b57214d44d0fec84$var$load("kQvbt"),
    $b57214d44d0fec84$var$load("jQFGH"),
    $b57214d44d0fec84$var$load("fQ1rW"),
    $b57214d44d0fec84$var$load("4tUsp"),
    $b57214d44d0fec84$var$load("6qah4"),
    $b57214d44d0fec84$var$load("9FBaW"),
    $b57214d44d0fec84$var$load("c6MKV"),
    $b57214d44d0fec84$var$load("aZinD"),
    $b57214d44d0fec84$var$load("cyGuT"),
    $b57214d44d0fec84$var$load("6Yu8N"),
    $b57214d44d0fec84$var$load("fnUik"),
    $b57214d44d0fec84$var$load("cfCop")
]).then(()=>parcelRequire('ecQiE'));

});


parcelRegister("6ld6a", function(module, exports) {

$parcel$export(module.exports, "useWebItemLocation", () => $f64809aa9d8f3ca2$export$13a30d244c53e90d);

var $diswb = parcelRequire("diswb");

var $jV49M = parcelRequire("jV49M");

var $jIQq0 = parcelRequire("jIQq0");

var $fjiOd = parcelRequire("fjiOd");

var $62BfR = parcelRequire("62BfR");
const $f64809aa9d8f3ca2$export$13a30d244c53e90d = ({ location: location, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null, fetchPolicy: fetchPolicy = 'cache-and-network', allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery })=>{
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $fjiOd.WebItemLocationQuery), {
        fetchPolicy: fetchPolicy,
        variables: {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        },
        skip: skipQuery
    });
    if (!data) return {
        loading: loading,
        error: error,
        webItems: [],
        webSections: []
    };
    // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
    // with the atlToken in all section items
    const webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections, {
        allowedWebItems: allowedWebItems,
        notAllowedWebItems: notAllowedWebItems
    });
    const webSections = (0, (/*@__PURE__*/$parcel$interopDefault($jIQq0)))(webItems.map((webItem)=>webItem.section));
    webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
    return {
        // Since the default fetchPolicy is cache-and-network
        // loading field will be true, false, true (background refetch), false
        // Query is refreshing when data not empty but loading is true
        // Padding loading false to avoid reverting back to the empty state or loading skeleton.
        // This aligns with confluence/next/packages/web-item-location/src/WebItemLocation.tsx
        loading: false,
        error: error,
        webItems: webItems,
        webSections: webSections
    };
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (item === null || item.completeKey === null) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};

});

parcelRegister("3SLf9", function(module, exports) {

$parcel$export(module.exports, "useIsAllowedToChangeOwner", () => $93ff62a422a2769d$export$fe5ee8722fdedf98);

var $gwFzn = parcelRequire("gwFzn");

var $bQm3c = parcelRequire("bQm3c");

var $5k5SG = parcelRequire("5k5SG");
const $93ff62a422a2769d$export$fe5ee8722fdedf98 = (ownedByAccountId)=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isSpaceOrSiteAdmin = (0, $5k5SG.useIsSpaceOrSiteAdmin)();
    return (0, $gwFzn.useMemo)(()=>{
        if (!userId) return false;
        const isCurrentUserOwner = ownedByAccountId === userId;
        return isSpaceOrSiteAdmin || isCurrentUserOwner;
    }, [
        isSpaceOrSiteAdmin,
        ownedByAccountId,
        userId
    ]);
};

});

parcelRegister("9TOhM", function(module, exports) {

$parcel$export(module.exports, "useGetClassificationTagUIVariant", () => $5b06a9a89418566a$export$9dbd9e1965ba2157);

var $hl0fg = parcelRequire("hl0fg");

var $9wGTI = parcelRequire("9wGTI");

var $e4o8D = parcelRequire("e4o8D");

var $1u6lx = parcelRequire("1u6lx");
const $5b06a9a89418566a$export$4ad2c8d6c7cae594 = 1000;
const $5b06a9a89418566a$var$CONTENT_TITLE_MAX_LENGTH = 25;
const $5b06a9a89418566a$var$CLASSIFICATION_NAME_MAX_LENGTH = 25;
const $5b06a9a89418566a$var$TOTAL_MAX_LENGTH = $5b06a9a89418566a$var$CONTENT_TITLE_MAX_LENGTH + $5b06a9a89418566a$var$CLASSIFICATION_NAME_MAX_LENGTH;
// ~ "Add classification", in English
const $5b06a9a89418566a$var$APPROX_ADD_BUTTON_CHAR_LENGTH = 18;
const $5b06a9a89418566a$export$9dbd9e1965ba2157 = ({ contentTitle: contentTitle = '', classificationName: classificationName = '' })=>{
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const contentTitleLength = contentTitle.length;
    const tagLabelLength = classificationName === '' ? $5b06a9a89418566a$var$APPROX_ADD_BUTTON_CHAR_LENGTH : classificationName.length;
    const combinedLength = contentTitleLength + tagLabelLength;
    const isIconOnly = (0, $9wGTI.fg)('confluence_frontend_object_header') ? windowWidth < $5b06a9a89418566a$export$4ad2c8d6c7cae594 : windowWidth < $5b06a9a89418566a$export$4ad2c8d6c7cae594 && combinedLength > $5b06a9a89418566a$var$TOTAL_MAX_LENGTH;
    // window is not availble in SSR so we need to need to render
    // the icon only while hydrating
    return isIconOnly || renderServerPlaceholder ? (0, $1u6lx.TagButtonUIVariant).iconOnly : (0, $1u6lx.TagButtonUIVariant).default;
};

});

parcelRegister("cuWTe", function(module, exports) {

$parcel$export(module.exports, "getContentMode", () => $52d439f2e3e46670$export$5d6b4e71896e8f23);
const $52d439f2e3e46670$export$5d6b4e71896e8f23 = (contentType, isArchived, isDraft, isViewEditOrLive)=>{
    // archived takes priority, since other modes like 'view' can be in this state
    if (isArchived) return 'archived';
    // useGetPageMode *always* returns one of 'live', 'view', or 'edit', but these modes don't apply across all
    // content types - so the content type doesn't have a 'mode' and we should return undefined
    if (contentType === 'page' || contentType === 'blogpost') {
        // then draft takes next priority, since other modes like 'edit' can be in this state
        if (isDraft) return 'draft';
        // technically only pages can be live at the moment, and blogposts wouldn't ever return live, but they *could*
        return isViewEditOrLive;
    } else return undefined;
};

});

parcelRegister("asQED", function(module, exports) {

$parcel$export(module.exports, "SHARE_BTN_STYLE", () => $27cf6bbb40785c7e$export$392ec14fa63f4ae3);
$parcel$export(module.exports, "WebItemList", () => $27cf6bbb40785c7e$export$63286b959e8d28b9);

var $6qIXK = parcelRequire("6qIXK");

var $fppBw = parcelRequire("fppBw");

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $7XPIt = parcelRequire("7XPIt");

var $9A8VL = parcelRequire("9A8VL");

var $dIouf = parcelRequire("dIouf");

var $ht0Th = parcelRequire("ht0Th");

var $hAnPj = parcelRequire("hAnPj");

var $glaQ8 = parcelRequire("glaQ8");

var $lTH0u = parcelRequire("lTH0u");

var $hFGQl = parcelRequire("hFGQl");
var $1CpUP = parcelRequire("1CpUP");

var $hfPJk = parcelRequire("hfPJk");
const $27cf6bbb40785c7e$export$392ec14fa63f4ae3 = {
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    display: 'inline-block',
    verticalAlign: 'top',
    paddingLeft: "var(--ds-space-100, 8px)"
};
const $27cf6bbb40785c7e$export$63286b959e8d28b9 = (props)=>{
    const { webItems: webItems, actions: actions, modifications: modifications, className: className, id: id, disableIcons: disableIcons, webItemClassName: webItemClassName, ContainerTagName: ContainerTagName, pageId: pageId, dataTestId: dataTestId, contentSubType: contentSubType, hideDot: hideDot, source: source, noContainer: noContainer = false, useBadgeStyles: useBadgeStyles = false } = props;
    const { isUSDExperimentEnabled: isUSDExperimentEnabled } = (0, $hfPJk.useUnifiedShareDialogEligible)(true);
    const renderWebItems = ()=>webItems.map((webItem)=>{
            const webItemProps = {
                key: webItem.completeKey,
                url: webItem.url,
                id: webItem.id,
                onClick: webItem.onClick || actions[webItem.moduleKey],
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6qIXK)))(webItem.styleClass, webItemClassName, {
                    'with-dot': // For live pages, hideDot will be true and we don't want to show dot separator
                    !hideDot
                }),
                params: webItem.params,
                iconInfo: webItem.icon,
                label: webItem.label,
                tooltip: webItem.tooltip,
                spinner: modifications[webItem.moduleKey] ? modifications[webItem.moduleKey].spinner : false,
                disableIcon: disableIcons,
                iconStyle: webItem.iconStyle,
                addLargerMargin: hideDot,
                useBylineStyles: hideDot
            };
            // Wow! The JIRA metadata item needs this data prop to work correctly! That was an easy debug ha hoo
            if (webItem.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID)) webItemProps['data-jira-metadata-count'] = -1;
            // "Unpublished Changes" lozenge
            if (pageId && webItem.id === (0, $hFGQl.DRAFT_STATUS_LOZENGE_ID)) {
                if (webItem.moduleKey === (0, $hFGQl.SCHEDULED_STATUS_LOZENGE_ID)) // Only show "Scheduled publish" lozenge
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9A8VL.ScheduledStatus), {
                    key: pageId,
                    contentId: pageId
                });
                else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9A8VL.DraftStatus), {
                    key: pageId,
                    contentId: pageId
                });
            }
            // TODO(brizvash): move the button to header, no need to check it all the time
            if (webItem.id === (0, $hFGQl.CONTENT_METADATA_ATTACHMENTS_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7XPIt.ViewAttachmentsButton), {
                key: "view-attachments-button"
            });
            if (webItem.id === (0, $hFGQl.INVITE_TO_EDIT_ID)) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                style: $27cf6bbb40785c7e$export$392ec14fa63f4ae3,
                key: "fabric-share"
            }, (0, $9wGTI.fg)('confluence_frontend_unified_restrict_and_share') || isUSDExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
                attribution: (0, $dIouf.Attribution).PERMISSIONS_EXPERIENCE,
                key: "share-and-restrict-button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lTH0u.ShareAndRestrictButton), {
                contentId: webItem.contentId,
                contentType: webItem.contentType ?? 'page',
                contentSubType: contentSubType || undefined,
                source: source
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $glaQ8.ShareButton), {
                contentId: webItem.contentId,
                contentSubType: contentSubType || undefined
            })));
            if (webItem.id === (0, $hFGQl.CONTENT_METADATA_PAGE_RESTRICTIONS_ID)) // Dialog is already attached to view page level
            return (0, $9wGTI.fg)('confluence_frontend_unified_restrict_and_share') || isUSDExperimentEnabled ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
                attribution: (0, $dIouf.Attribution).PERMISSIONS_EXPERIENCE,
                key: "restrictions-dialog-trigger"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hAnPj.RestrictionsDialogTrigger), {
                contentId: webItem.contentId,
                triggeredFrom: "fromView",
                contentSubType: contentSubType
            }));
            if (webItem.id === (0, $hFGQl.ANALYTICS_ADDON_ACTIONS_MENU_ID) || webItem.id === (0, $hFGQl.ANALYTICS_ADDON_BYLINE_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null);
            if (webItem.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ht0Th.JiraButtonAnalyticsWrapper), {
                key: webItem.completeKey
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1CpUP.WebItem), webItemProps));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1CpUP.WebItem), {
                key: webItem.completeKey,
                ...webItemProps,
                useBadgeStyles: useBadgeStyles
            });
        });
    if (noContainer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, renderWebItems());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(ContainerTagName, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        id: id,
        "data-test-id": dataTestId,
        "data-testid": dataTestId || 'web-item-wrapper'
    }, renderWebItems());
};
$27cf6bbb40785c7e$export$63286b959e8d28b9.displayName = 'WebItemList';
$27cf6bbb40785c7e$export$63286b959e8d28b9.defaultProps = {
    disableIcons: false,
    ContainerTagName: 'div',
    actions: {},
    modifications: {},
    noContainer: false,
    useBadgeStyles: false
};
$27cf6bbb40785c7e$export$63286b959e8d28b9.propTypes = {
    webItems: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).array,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
    modifications: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    disableIcons: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    ContainerTagName: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    webItemClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    pageId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    dataTestId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    hideDot: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    noContainer: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool
};

});
parcelRegister("9A8VL", function(module, exports) {

$parcel$export(module.exports, "DraftStatus", () => $ea8af3e940686137$export$ad9db10db9173ca8);
$parcel$export(module.exports, "ScheduledStatus", () => $ea8af3e940686137$export$d10c0abe99daab65);

var $jmjWc = parcelRequire("jmjWc");

const $ea8af3e940686137$export$ad9db10db9173ca8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wCm_G",
    name: "DraftStatus",
    loader: async ()=>(await (parcelRequire("cbSZ7"))).DraftStatus
});

const $ea8af3e940686137$export$d10c0abe99daab65 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "z2GD3",
    name: "ScheduledStatus",
    loader: async ()=>(await (parcelRequire("lMDSR"))).ScheduledStatus
});

});
parcelRegister("cbSZ7", function(module, exports) {

let $8e0129f864894649$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8e0129f864894649$var$load("jYr96").then(()=>parcelRequire('1cgZV'));

});

parcelRegister("lMDSR", function(module, exports) {

let $fdbd04cb1567edcc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fdbd04cb1567edcc$var$load("iWKl1").then(()=>parcelRequire('dqNU1'));

});


parcelRegister("ht0Th", function(module, exports) {

$parcel$export(module.exports, "JiraButtonAnalyticsWrapper", () => $cb75d5f0a986326c$export$549130614231f8f4);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $inPa6 = parcelRequire("inPa6");

var $2UWuP = parcelRequire("2UWuP");

var $hFGQl = parcelRequire("hFGQl");
const $cb75d5f0a986326c$var$JIRA_ANALYTICS = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        source: 'viewPageScreen',
        actionSubject: 'JiraTicketsButton'
    }
};
function $cb75d5f0a986326c$export$549130614231f8f4({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const container = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        setTimeout(()=>{
            let linkVisible = false;
            const link = container?.current?.children?.[0, $hFGQl.CONTENT_METADATA_JIRA_ID];
            if (link && !link.classList.contains('hidden')) linkVisible = true;
            if (linkVisible) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: 'JiraTicketsButton',
                    action: 'shown',
                    source: 'viewPageScreen',
                    attributes: {
                        isPageSSRd: window.__SSR_RENDERED__
                    }
                }
            }).fire();
        }, 5000); // should be enough for render after the plugin has mounted
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
        analyticsData: $cb75d5f0a986326c$var$JIRA_ANALYTICS,
        innerRef: container,
        wrapChildren: true
    }, children);
}
$cb75d5f0a986326c$export$549130614231f8f4.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).node
};

});

parcelRegister("1CpUP", function(module, exports) {

$parcel$export(module.exports, "WebItem", () => $12dd715bfa1d104a$export$1c46d4b85d455dd4);
/* WebItem.js generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $6qIXK = parcelRequire("6qIXK");

var $bknsA = parcelRequire("bknsA");

var $fppBw = parcelRequire("fppBw");

var $gwFzn = parcelRequire("gwFzn");

var $9hlns = parcelRequire("9hlns");

var $3gadb = parcelRequire("3gadb");

var $bCECL = parcelRequire("bCECL");
function $12dd715bfa1d104a$var$_defineProperty(e, r, t) {
    return (r = $12dd715bfa1d104a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $12dd715bfa1d104a$var$_toPropertyKey(t) {
    var i = $12dd715bfa1d104a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $12dd715bfa1d104a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $12dd715bfa1d104a$var$imageStyles = null;
// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
const $12dd715bfa1d104a$var$baseStyles = null;
const $12dd715bfa1d104a$var$largeMargin = null;
const $12dd715bfa1d104a$var$bylineStyles = null;
const $12dd715bfa1d104a$var$badgeStyles = null;
const $12dd715bfa1d104a$var$WebItemTooltip = ({ tooltip: tooltip, children: children })=>{
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: tooltip
    }, (tooltipProps)=>children(tooltipProps));
    return children({});
};
$12dd715bfa1d104a$var$WebItemTooltip.propTypes = {
    /**
   * Tooltip of the web item
   */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired
};
const $12dd715bfa1d104a$var$WebItemIcon = ({ classes: classes, id: id, url: url, label: label, tooltip: tooltip, onClick: onClick, style: style, icon: icon, addLargerMargin: addLargerMargin, useBylineStyles: useBylineStyles, useBadgeStyles: useBadgeStyles, ...otherProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($12dd715bfa1d104a$var$WebItemTooltip, {
        tooltip: tooltip
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
            "data-testId": "web-item-link" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            ,
            className: (0, $35pXk.default)([
                "_2hwxu2gc _vwz4bs82",
                addLargerMargin && "_2hwx14h2 _vwz41vhj",
                useBylineStyles && "_syazp1wj",
                useBadgeStyles && "_2rkoglpi _zulp1b66 _1yt41b66 _4bfu18uv _1hmsglyw _ajmmnqa1 _1e0c1txw _vwz47vkz _2hwxze3t _9oik18uv _1bnxglyw _jf4cnqa1 _irr3166n _1bnxagmp _1di61dty _c2waglyw",
                classes
            ]),
            href: url,
            id: id,
            onClick: onClick,
            style: style,
            ...tooltipProps,
            ...otherProps
        }, icon, typeof label === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            dangerouslySetInnerHTML: {
                __html: label
            }
        }) : label));
};
$12dd715bfa1d104a$var$WebItemIcon.propTypes = {
    /**
   * classes to use for the component
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    /**
   * id passed from WebItem
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    /**
   * Route where the web item will point
   */ url: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    /**
   * Label of the web item
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    /**
   * Tooltip of the web item
   */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    /**
   * Handler for clicks
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    /**
   * WebItem styles
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
    /**
   * Icon obj
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
    /**
   * Will be true for live pages since apps have different styling
   */ addLargerMargin: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    /**
   * Will be true for live pages since apps have different styling
   */ useBylineStyles: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool
};
class $12dd715bfa1d104a$export$1c46d4b85d455dd4 extends (0, $gwFzn.PureComponent) {
    getIcon() {
        const { disableIcon: disableIcon, params: params, iconStyle: iconStyle, spinner: spinner, iconInfo: iconInfo, label: label, iconSize: iconSize } = this.props;
        let auiIconClass = params && params.iconClass;
        if (disableIcon) return null;
        if (spinner) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
            testId: "spinner",
            size: "small"
        });
        if (iconInfo && iconInfo.path) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("img" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        , {
            style: iconStyle,
            src: iconInfo.path,
            width: iconInfo.width,
            height: iconInfo.height,
            alt: label,
            title: label,
            className: (0, $35pXk.default)([
                "_c71l1osq _4t3i1wug _1e0c1o8l _s7n4nkob _2hwx14y2"
            ])
        });
        if (auiIconClass) {
            if (auiIconClass.indexOf('aui-iconfont-') === -1) auiIconClass = `aui-iconfont-${auiIconClass}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bCECL.ContentIcon), {
                iconSize: iconSize,
                className: auiIconClass,
                style: iconStyle
            });
        }
        return null;
    }
    render() {
        const { className: className, id: id, url: url, type: type, label: label, tooltip: tooltip, onClick: onClick, style: style, ...otherProps } = this.props;
        const buttonType = type === 'primary' ? 'aui-button-primary' : '';
        const classes = (0, (/*@__PURE__*/$parcel$interopDefault($6qIXK)))(className, buttonType);
        const icon = this.getIcon(); //react complains about these extra props but we still need to pass otherProps (e.g. data-jira-metadata-count)
        const webItemIconProps = (0, (/*@__PURE__*/$parcel$interopDefault($bknsA)))({
            classes: classes,
            id: id,
            url: url,
            label: label,
            tooltip: tooltip,
            onClick: onClick,
            style: style,
            icon: icon,
            ...otherProps
        }, [
            'disableIcon',
            'iconStyle',
            'spinner',
            'iconInfo',
            'iconSize'
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($12dd715bfa1d104a$var$WebItemIcon, webItemIconProps);
    }
}
$12dd715bfa1d104a$var$_defineProperty($12dd715bfa1d104a$export$1c46d4b85d455dd4, "propTypes", {
    /**
   * Classnames. Note that WebItem no longer assumes that it should render as a button
   * And as such you may need to explicitly pass the `aui-button` class here.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    /**
   * id
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    /**
   * Route where the web item will point
   */ url: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    /**
   * Type of the button
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    /**
   * Label of the web item
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    /**
   * Tooltip of the web item
   */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    /**
   * Handler for clicks
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    /**
   * Contain parameters setted in the descriptor
   */ params: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
    /**
   * Doesn't render icons when true
   */ disableIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    /**
   * icon information used for absolute images
   */ iconInfo: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).shape({
        path: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).number,
        height: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).number
    }),
    /**
   * Show spinner instead of an icon if equals true
   */ spinner: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    /**
   * WebItem styles
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
    /**
   * Icon styles
   */ iconStyle: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
    iconSize: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    /**
   * Will be true for live pages since apps have different styling
   */ addLargerMargin: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    /**
   * Will be true for live pages since apps have different styling
   */ useBylineStyles: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool
});
$12dd715bfa1d104a$var$_defineProperty($12dd715bfa1d104a$export$1c46d4b85d455dd4, "defaultProps", {
    spinner: false,
    iconStyle: {},
    style: {},
    iconSize: 'small'
});

});



//# sourceMappingURL=EditorByLineArea.903cc1f5.js.map
